/* eslint-env jquery */
// Main JS File
import ol from './ol';
import shp from 'shpjs';
import { reproject } from 'reproject';
import 'whatwg-fetch';
import { downloadSamples, downloadFile, downloadTitles, downloadJSON } from './FileFunctions';
import {
  addressForm,
  handleLayerRestrictions,
  activateCheckboxes,
  showHideSidebar,
  createSavedCard,
  buildLayerList,
  setArea,
  populatePrimary,
} from './UIFunctions';
import { GT_OSGB, GT_WGS84, jsts_validate } from './geotools';
import { closeInfo, infoPanelSetup, repopulateInfoBox } from './infoPanel';
import { closeWMS, showWMSInfo } from './wmsInfoPanel';
import { doUndo, doRedo } from './UndoRedo';
import { getInsight, clearInsight, getPlanningApplications } from './Planning';
import { getLineSearch, clearLineSearch } from './LineSearch';
import { Utils } from './classes/Utils';
import {
  showSection,
  removeDuplicates,
  hideSection,
  showArea,
  logPlanningView,
  hasSeen,
  clearTempMarkup,
  setCursor,
  showError,
  messages,
  saveB64,
  //  distanceBetween,
} from './helpers';
import * as settings from './settings.js';
import { calculatePrice, recalculatePrice, pricing } from '../../schemas/pricing';
import { help } from './help';
import { state, colors } from './state';
import { Styles } from './classes/Styles';
import { EventBroker } from './EventBroker';
import { ServiceCalls } from './serviceCalls';
import { setCookie, getCookie, deleteCookie } from './modules/cookies';
import { addLinesearch, addPlanning, setupWFS, setupBasemap, addNewWFS, addNewWMS } from './LayerFunctions';
window.state = state;
const util = new Utils();
const styles = new Styles();
// Called when hovering over features
const setRestricted = extent => {
  ol.map.setOptions({ restrictedExtent: extent });
};
const getCoordsFromUPRNs = list => {
  const obj = { uprns: list };
  ServiceCalls.callService('getCoordsFromUPRN', obj);
  $('#uprns').hide();
};
const toolFunctions = {
  path: activatePath,
  flood: activateFill,
  poly: () => activatePoly(true),
  snapshot: showSnapshotOrder,
  title: activateTitle,
  boundary: activateBoundary,
  pan: () => activatePan(true),
  overview: () => ol.controls.doubleClickOverview.activate(),
  intersect: activateIntersect,
  select: () => {
    activateSelect();
    $('#arrow-control').parent().addClass('active');
  },
  'delete-all': activateDeleteAll,
  delete: activateDelete,
};

const disableLayers = bool => {
  if (!settings.isDev) {
    if (bool) {
      $('.bottom-row').addClass('disabled');
      ol.arrays.heldLayers = [...ol.arrays.addedLayers, ...ol.arrays.addedWFSLayers];
      if ($('*[data-layer="planning"').is(':checked')) ol.arrays.heldLayers.push('planning');
      if ($('*[data-layer="lineSearch"').is(':checked')) ol.arrays.heldLayers.push('lineSearch');
      activateTool(null, 'overview');
    } else {
      $('.bottom-row').removeClass('disabled');
      updateRelevancy();
      activateTool(null, 'pan');
    }
    ol.arrays.heldLayers.forEach(l => {
      $(`*[data-layer="${l}"]`).each((index, obj) => $(obj).click());
      Object.keys(settings.alternateLayers).forEach(k => {
        if (settings.alternateLayers[k] === l) $(`*[data-layer="${k}"]`).each((index, obj) => $(obj).click());
      });
    });
  }
};
const updateRelevancy = () => {
  state.currentCenter = { x: ol.map.center.lon, y: ol.map.center.lat };
  const e = ol.map.getExtent();
  const extent = {
    left: e.left,
    right: e.right,
    top: e.top,
    bottom: e.bottom,
  };
  ServiceCalls.callService('getLayersFromExtent', { extent });
};

const setClicks = () => {
  ol.layers.vector.events.un({ featureclick: featClick });
  ol.layers.vector.events.on({ featureclick: featClick });
  ol.layers.vector2.events.un({ featureclick: polyClick });
  ol.layers.vector2.events.on({ featureclick: polyClick });
};
const callFeatureOver = e => {
  const {
    queryActive: qa,
    boundaryActive: ba,
    selectActive: sa,
    infoActive: ia,
    drawActive: da,
    planningActive: pa,
    modifyActive: ma,
  } = state;
  const feat = e.feature;
  if (!qa && !ba) {
    state.overStatus = true;
    if (feat.type != 'annotation' && !sa && feat.style.display !== 'block') {
      state.overcount++;
      if (!ia && !da) {
        setArea({ feat, pa });
        feat.type !== 'property' && ol.controls.click.deactivate();
      }
    } else if (sa && !ma) {
      setArea({ feat, pa });
    }
  }
};
// Change style of search area polygons on click
const selClick = e => {
  const feat = e.feature;
  const fo = feat.style.fillOpacity == 0.45;
  feat.style.fillOpacity = fo ? 0.75 : 0.45;
  feat.style.strokeOpacity = fo ? 0.75 : 0.45;
  feat.style.fillColor = fo ? colors.faintred : colors.midgrey;
  feat.style.strokeColor = fo ? colors.faintred : colors.midgrey;
  ol.layers.vectorSel.redraw();
};

// Non-title polygon click handler
const showGeometryError = (points, zoom) => {
  const p = points[0];
  const errorPoint = new OpenLayers.Geometry.Point(p[0], p[1]);
  ol.points.error = new OpenLayers.Feature.Vector(errorPoint, null, {
    graphicName: 'circle',
    fillOpacity: 0.75,
    pointRadius: 8,
    fillColor: colors.fullgreen,
    strokeColor: colors.black,
    strokeWidth: 1,
    display: 'block',
  });

  ol.layers.error.addFeatures([ol.points.error]);
  ol.map.raiseLayer(ol.layers.error, ol.map.layers.length);
  if (zoom) ol.map.setCenter(new OpenLayers.LonLat(errorPoint.x, errorPoint.y), 11);
  else ol.map.setCenter(new OpenLayers.LonLat(errorPoint.x, errorPoint.y));
  if (ol.popup) {
    ol.map.removePopup(ol.map.popups[0]);
    ol.popup = null;
  }
  ol.popup = new OpenLayers.Popup(
    'Popup',
    new OpenLayers.LonLat(errorPoint.x, errorPoint.y),
    new OpenLayers.Size(160, 20),
    '<div class="popupLabel"> Invalid Crossover</div>',
    false,
    false,
  );
  ol.popup.backgroundColor = colors.darkgreen;
  ol.map.addPopup(ol.popup);
  ol.popup.hide();
  ol.layers.error.events.on({
    featureover: function () {
      ol.popup.show();
    },
    featureout: function () {
      ol.popup.hide();
    },
  });
};
const polyClick = e => {
  if (state.useExisting) {
    useExistingClick(e);
    return;
  }
  if (state.planningActive) {
    clearInsight({ ol, state });
    state.clickedFeatures = [];
    const xy = ol.map.getLonLatFromViewPortPx({
      x: event.offsetX,
      y: event.offsetY,
    });
    const pt = new OpenLayers.Geometry.Point(xy.lon, xy.lat);
    let comp = null;
    ol.layers.vector2.features.forEach(feat => {
      if (feat.geometry.id.indexOf('Multi') > -1) {
        feat.geometry.components.forEach(c => {
          if (c.containsPoint(pt)) comp = c;
        });
      } else if (typeof feat.geometry.containsPoint !== 'undefined') {
        if (feat.geometry.containsPoint(pt)) comp = feat.geometry;
      }
    });
    if (comp) {
      state.planningFeat = comp;
      setCursor({ type: 'progress' });
      getInsight({ state, styles, ol });
    }
  } else if (state.lineSearchActive) {
    clearInsight({ ol, state });
    state.clickedFeatures = [];
    const xy = ol.map.getLonLatFromViewPortPx({
      x: event.offsetX,
      y: event.offsetY,
    });
    const pt = new OpenLayers.Geometry.Point(xy.lon, xy.lat);
    let comp = null;
    ol.layers.vector2.features.forEach(feat => {
      if (feat.geometry.id.indexOf('Multi') > -1) {
        feat.geometry.components.forEach(c => {
          if (c.containsPoint(pt)) comp = c;
        });
      } else if (typeof feat.geometry.containsPoint !== 'undefined') {
        if (feat.geometry.containsPoint(pt)) comp = feat.geometry;
      }
    });
    if (comp) {
      state.planningFeat = comp;
      setCursor({ type: 'progress' });
      getLineSearch({ state, styles, ol });
    }
  } else {
    if (e.feature.style.strokeColor == colors.green && state.snapsActive) {
      state.clickedFeature = e.feature;
      state.snapsActive = true;
      if (!state.getting) {
        state.getting = true;
        getIntersects(e);
      } else {
        console.info('Notice: already retrieving titles');
      }
    }
  }
};

// Planning application click handler
const planningclick = e => {
  if (ol.points.marker2) {
    ol.layers.vectorPin.destroyFeatures([ol.points.marker2]);
  }
  const evt = event || window.event;
  e.feature.xy = evt.xy;
  showWMSInfo({ evt: e.feature, state, ol, settings });
  evt.stopPropagation();
  evt.preventDefault();
  ol.layers.planningLayer.setZIndex(2007);
};

const lineSearchclick = e => {
  if (ol.points.marker2) {
    ol.layers.vectorPin.destroyFeatures([ol.points.marker2]);
  }
  const evt = event || window.event;
  e.feature.xy = evt.xy;
  showWMSInfo({ evt: e.feature, state, ol, settings });
  evt.stopPropagation();
  evt.preventDefault();
  ol.layers.lineSearchLayer.setZIndex(2008);
};

const featClick = e => {
  if (state.useExisting) {
    useExistingClick(e);
    return;
  }
  let pt, i, j, feat, hasPoint, xy;
  const evt = event || window.event;
  if (state.planningActive) {
    clearInsight({ ol, state });
    state.clickedFeatures = [];
    xy = ol.map.getLonLatFromViewPortPx({
      x: evt.offsetX,
      y: evt.offsetY,
    });
    pt = new OpenLayers.Geometry.Point(xy.lon, xy.lat);
    let comp = null;
    ol.layers.vector.features.forEach(feat => {
      if (feat.geometry.id.indexOf('Multi') > -1) {
        feat.geometry.components.forEach(c => {
          if (c.containsPoint(pt)) comp = c;
        });
      } else if (typeof feat.geometry.containsPoint !== 'undefined') {
        if (feat.geometry.containsPoint(pt)) comp = feat.geometry;
      }
    });
    if (comp) {
      if (comp.components[0].id.indexOf('Linear') > -1) comp = comp.components[0];
      state.planningFeat = comp;
      setCursor({ type: 'progress' });
      getInsight({ state, styles, ol });
    }
  } else if (state.lineSearchActive) {
    clearLineSearch({ ol, state });
    state.clickedFeatures = [];
    const xy2 = ol.map.getLonLatFromViewPortPx({
      x: evt.offsetX,
      y: evt.offsetY,
    });
    pt = new OpenLayers.Geometry.Point(xy2.lon, xy2.lat);
    let comp2 = null;
    ol.layers.vector.features.forEach(feat => {
      if (feat.geometry.id.indexOf('Multi') > -1) {
        feat.geometry.components.forEach(c => {
          if (c.containsPoint(pt)) comp2 = c;
        });
      } else if (typeof feat.geometry.containsPoint !== 'undefined') {
        if (feat.geometry.containsPoint(pt)) comp2 = feat.geometry;
      }
    });
    if (comp2) {
      if (comp2.components[0].id.indexOf('Linear') > -1) comp2 = comp2.components[0];
      state.lineSearchFeat = comp2;
      setCursor({ type: 'progress' });
      getLineSearch({ state, styles, ol });
    }
  } else if (evt.ctrlKey && evt.altKey) {
    showDialog(evt);
  } else {
    if (!state.queryActive && !state.boundaryActive && !state.moving) {
      state.clickedFeatures = [];
      xy = ol.map.getLonLatFromViewPortPx({
        x: evt.clientX - state.sidebarWidth,
        y: evt.clientY - 50,
      });
      pt = new OpenLayers.Geometry.Point(xy.lon, xy.lat);
      for (i = 0; i < ol.layers.vector.features.length; i++) {
        feat = ol.layers.vector.features[i];
        feat.style.fillColor = feat.style.strokeColor;
        feat.style.fillOpacity = 0;

        hasPoint = false;
        if (feat.geometry.id.indexOf('Multi') > -1) {
          for (j = 0; j < feat.geometry.components.length; j++) {
            if (feat.geometry.components[j].containsPoint(pt)) hasPoint = true;
          }
        } else if (typeof feat.geometry.containsPoint !== 'undefined') {
          if (feat.geometry.containsPoint(pt)) hasPoint = true;
        }
        if (hasPoint) {
          state.clickedFeatures.push(feat);
          feat.style.fillColor = feat.style.strokeColor;
          feat.style.fillOpacity = 0;
        }
        ol.layers.vector.redraw();
      }
      if (!state.overStatus || state.infoClosed) {
        state.overcount++;
        state.infoClosed = false;
      }
      if (state.overcount > 0) {
        if (
          !state.queryActive &&
          !state.boundaryActive &&
          !state.infoActive &&
          !state.drawActive &&
          !state.selectActive &&
          e.feature.type != 'annotation'
        ) {
          if (e.feature.style.display != 'block') {
            if (state.annotation) {
              ol.controls.modifyFeature.unselectFeature(state.annotation);
              ol.layers.vector2.redraw();
            }
            state.annotation = null;
            ol.controls.modifyFeature.deactivate();
            infoPanelSetup({ state, ol, styles });
          }
        } else if (e.feature.type == 'annotation') {
          state.annotation = e.feature;
          ol.controls.modifyFeature.selectFeature(state.annotation);
          ol.controls.click.deactivate();
        }
      }
    }
  }
};

const layerOver = e => {
  const layerId = $(e.currentTarget).attr('id');
  if (util.layerInfo[layerId]) {
    $('#layerInfo .li_title').html(util.layerInfo[layerId].title);
    $('#layerInfo .li_content').html(util.layerInfo[layerId].text);
    $('#layerInfo').stop(true, true).fadeIn(400);
  }
};
const layerOut = () => {
  $('#layerInfo').stop(true, true).fadeOut(300);
};

const busyPointer = e => {
  if (e && e.object && e.object.layers) {
    let wmsQuery = {};
    e.object.layers.forEach(o => {
      if (o.url) {
        if (o.url.includes('/proxy')) {
          const regex = /[^/]+$/;
          wmsQuery[o.name] = o.url.match(regex)[0];
          o.params.LAYERS = `${o.name.replace(/,/g, '~')}:${o.url.match(regex)[0].replace(/,/g, '~')}`;
        }
      }
    });
    state.wmsQuery = wmsQuery;
  }
  setCursor({ type: 'progress' });
};

const showTab = (tab, toshow) => {
  if (ol.arrays.wmsFeatureArray['planningapplications']) {
    const item = ol.arrays.wmsFeatureArray['planningapplications'][0].attributes[toshow];
    if (!hasSeen({ item })) {
      state.seenItems.push(item);
      ServiceCalls.callService('logPlanningView', {
        guid: guid,
        xy: `(${state.planningCenter.x},${state.planningCenter.y})`,
      });
      if (!settings.skipPlanningLog) logPlanningView({ item, settings });
    }
  }
  $('.tab-pane').removeClass('active');
  $(`#${tab}-${toshow}-tab`).addClass('active');
};

const closeAddress = () => {
  $('#address-panel').hide();
};

const showInitialBoundary = ses => {
  const geojson = new OpenLayers.Format.GeoJSON();
  let newStyle, feat;
  let layersfound = false;
  for (let n = 0; n < ses.length; n++) {
    feat = typeof ses[n].polygon !== 'undefined' ? geojson.read(ses[n].polygon) : geojson.read(ses[n]);
    if (!layersfound) {
      if (feat[0].properties) {
        feat[0].attributes = { ...feat[0].properties };
      }
      if (feat[0].attributes.overlays) {
        layersfound = true;
        feat[0].attributes.overlays.split('|').forEach(data => {
          if (data.search('-') != -1) {
            data = data.split('-');
            $(`*[data-layer="${data[0]}"][data-filter="${data[1]}"]`).click();
          } else {
            $(`*[data-layer="${data}"]`).click();
          }
        });
      }
    }
    if (typeof ses[n].geometry === 'undefined' || ses[n].geometry.type != 'Point') {
      setupFeature(feat, ses[n], n, false);
    }
  }
  if (anno) {
    const v2 = JSON.parse(anno).features;
    for (let n = 0; n < v2.length; n++) {
      feat = typeof v2[n].polygon !== 'undefined' ? geojson.read(v2[n].polygon) : geojson.read(v2[n]);
      if (v2[n].properties.color === colors.green) {
        $('#intersect-tool').show();
        newStyle = { ...styles.propertyStyle };
        feat[0].style = styles.augment(newStyle, colors.green, 4, 0);
        feat[0].type = 'property';
        feat[0].subtype = 'property';
        feat[0].style = newStyle;
        state.snapshotFeatures = [feat[0]];
      } else {
        newStyle = { ...styles.defaultStyle };
        const props = v2[n].properties;
        feat[0].style = styles.augment(newStyle, props.color, 2, props.fillOpacity, props.fillColor);
        feat[0].type = 'annotation';
      }
      ol.layers.vector2.addFeatures(feat);
    }
  }
  $('#info-layer-switch').prop('checked', false);
  activateTool(null, 'pan');
  const extent = ol.layers.vector.getDataExtent();
  if (extent) {
    ol.map.zoomToExtent(extent);
    ol.map.zoomTo(ol.map.getZoom() > 12 ? 12 : ol.map.getZoom());
  }
  featuresRemoved();
};

const showLRBoundary = evt => {
  setCursor({ type: state.currentCursor });
  if (evt.response == 'no records found') {
    showError({
      state,
      title: 'No Land Registry boundary found at that point',
      message: messages.unregistered,
    });
  } else {
    const json = JSON.parse(evt.response);
    const geojson = new OpenLayers.Format.GeoJSON();
    json.forEach(value => {
      const feat = geojson.read(JSON.parse(JSON.stringify(value.polygon)));
      setupFeature(feat, value, 0, false);
    });
    ol.layers.vector.redraw();
  }
  storeSession();
};

function setupFeature(feat, item, n, found) {
  feat.type = 'title';
  if (typeof item.properties !== 'undefined') item = item.properties;
  let inc = [];
  feat.forEach(f => {
    if (typeof f.attributes.progress == 'undefined') {
      const { daylist, corporate, overseas, ...strippedItem } = item;
      f.attributes = { ...strippedItem };
      if (state.polysearch) {
        f.attributes.polysearch = state.polysearch;
      }
      let attr = f.attributes;
      attr.title_no = item.title;
      attr.address = buildAddress(item, false);
      if (attr.address !== '-') {
        attr.add_source = 'OS AddressBase Premium';
        attr.add_source_descr = 'Accurate address location';
      } else {
        attr.add_source = 'Google Addresses';
        attr.add_source_descr = 'Approximate address location';
      }
      attr.bb_centroid = item.centre;
      if (item.insert_date) attr.insert_date = item.insert_date.split(' ')[0];
      if (item.update_date) attr.update_date = item.update_date.split(' ')[0];
      attr.registered_status = item.status;
      attr.class_of_title = item.title_class;
      let idx, obj;
      if (item.corporate) {
        attr.corporate = [];
        if ($.isArray(item.corporate)) {
          for (idx = 0; idx < item.corporate.length; idx++) {
            obj = {};
            $.each(item.corporate[idx], function (key, value) {
              if (value !== null) {
                obj[key] = value;
              }
            });
            attr.corporate.push(obj);
          }
        }
      }
      if (item.daylist) {
        attr.daylist = [];
        if ($.isArray(item.daylist)) {
          for (idx = 0; idx < item.daylist.length; idx++) {
            obj = {};
            $.each(item.daylist[idx], function (key, value) {
              if (value !== null) {
                obj[key] = value;
              }
            });
            attr.daylist.push(obj);
          }
        }
      }

      if (item.overseas) {
        $.each(item.overseas, function (key, value) {
          if (value !== null) {
            attr[key] = value;
            item[key] = value;
          }
        });
        for (let m = 1; m < 5; m++) {
          const prop = `proprietor_${m}`;
          const add = `address${m}`;
          if (item[`${prop}_address_1`]) {
            attr[add] = item[`proprietor_name_${m}`] + ', ' + item[`${prop}_address_1`];
            if (item[`${prop}_address_2`]) attr[add] += ', ' + item[`${prop}_address_2`];
            if (item[`${prop}_address_3`]) attr[add] += ', ' + item[`${prop}_address_3`];
          }
        }
      }
    }
    let attr = f.attributes;
    f.style = { ...styles.defaultStyle };
    if (attr.class_of_title.match(/freehold/i)) f.style.strokeColor = colors.red;
    else if (attr.class_of_title.match(/leasehold/i)) f.style.strokeColor = colors.blue;
    else f.style.strokeColor = colors.black;
    f.type = 'title';
    f.style.strokeWidth = 2;
    f.style.fillOpacity = 0;
    if (attr.class_of_title.match(/freehold/i)) f.style.fontColor = colors.darkred;
    else if (attr.class_of_title.match(/leasehold/i)) f.style.fontColor = colors.darkblue;
    else f.style.fontColor = colors.darkgrey;
    f.style.fontWeight = 'bold';
    f = cleanPoly(f);
    inc.push(f);
    if (attr.progress == 'saved' || attr.progress == 'sent') {
      updateSavedFeature(f);
      if (project.status == 'freeze') {
        f.style.fillOpacity = 0.5;
        f.style.fillColor = colors.midgrey;
      }
    }
  });
  if (!found) ol.layers.vector.addFeatures(inc);
  storeSession();
}
const resetClicks = () => {
  $('#layer-list .layercb').off().on('click', addRemoveLayer);
  $('.nomm').on('click', e => {
    $(e.currentTarget).is(':checked') && ol.map.getZoom() > 10 && ol.map.zoomTo(10);
    addRemoveLayer(e);
  });
  $('.data_layers li').hover(layerOver, layerOut);
};

function setSliderEvents() {
  $('#lineSearch-range')
    .off('input change')
    .on('input change', function () {
      state.lsrad = parseInt(this.value);
      $('#lineSearch-radius').text(`${state.lsrad}m`);
      $('#info-layer-switch').prop('checked', true);
    });
  $('#lineSearch-range')
    .off('mouseup')
    .on('mouseup', function () {
      state.lsrad = parseInt(this.value);
      if (state.lineSearchFeat) {
        clearLineSearch({ ol, state });
        getLineSearch({ state, styles, ol });
      }
      $('#lineSearch-radius').text(`${state.lsrad}m`);
      $('#info-layer-switch').prop('checked', true);
      addRemoveInfo(null, 'lineSearch');
      addRemoveInfo(null);
    });

  $('#planning-range')
    .off('input change')
    .on('input change', function () {
      state.rad = parseInt(this.value);
      if (state.rad == 0) state.rad = 1;
      $('#planning-radius').text(`${state.rad}m`);
      $('#info-layer-switch').prop('checked', true);
    });
  $('#planning-range')
    .off('mouseup')
    .on('mouseup', function () {
      state.rad = parseInt(this.value);
      if (state.rad == 0) state.rad = 1;
      $('#planning-radius').text(`${state.rad}m`);
      $('#info-layer-switch').prop('checked', true);
      if (state.planningFeat) {
        clearInsight({ ol, state });
      }
      addRemoveInfo(null, 'planning');
      addRemoveInfo(null);
    });
}
function eventHandlers() {
  $(window).keydown(function (event) {
    state.curKey = event.which;
  });
  $(window).keyup(function () {
    state.curKey = null;
  });
  $('#close-address').click(closeAddress);
  $('#hide-overseas').click(function () {
    hideSection('overseas');
  });
  $('#hide-corporate').click(function () {
    hideSection('corporate');
  });
  $('#hide-daylist').click(function () {
    hideSection('daylist');
  });
  $('#close-info').click(() => closeInfo({ state, ol, featClick, setCursor, activateSelect }));
  $('#close-wms').click(() => closeWMS({ state, ol }));
  $('#show-hide-marker').click(showHideMarker);
  $('#show-hide-sv').click(showHideSV);
  $('#do-undo, #do-undo-other, #do-undo-flood').click(() => doUndo({ state, ol }));
  $('#do-redo, #do-redo-other, #do-redo-flood').click(() => doRedo({ state, ol }));
  $('#home').click(() => ol.functions.goHome({ state }));
  ['pan', 'select', 'snapshot', 'intersect', 'poly', 'delete', 'flood', 'delete-all'].forEach(t => {
    $(`#${t}-tool`).click(e => activateTool(e, t));
  });
  $('#snapshot_button').click(e => activateTool(e, 'title'));
  $('#layerSwitcher').click(() => {
    const currentvis = $('.base-layer').css('visibility') == 'hidden';
    $('.base-layer').css('visibility', currentvis ? 'visible' : 'hidden');
  });
  $('.base-layer label, .base-layer img').click(e => {
    $('.base-layer').css('background-color', colors.white);
    state.currentBM = $(e.currentTarget).parent().data().type;
    $(`#${state.currentBM}-toggle`).css('background-color', colors.orange);
    $(`#cb-${state.currentBM}`).click();
    $('.base-layer').css('visibility', 'hidden');
    event.stopPropagation();
  });

  $('#colorpicker').colorpicker({
    color: colors.red,
    strings: 'Shades, Standard Colours,Web Colours,Shades,Back to Palette,History,No history yet.',
    standardColors: colors.standard,
  });
  $('#colorpicker').on('change.color', (event, color) => {
    state.currentColor = color;
    if (state.annotation) state.annotation.style.strokeColor = state.currentColor;
    ol.layers.vector2.redraw();
  });
  $('#info-layer-switch').change(addRemoveInfo);
  $('#map').click(() => {
    if (event.ctrlKey && event.altKey) {
      showDialog(event);
    }
  });
  $('#casefile-ref').text(project.casefile_ref);
  setSliderEvents();
  $('.sublayercb').click(filterLayer);
  $.Topic('error').subscribe(errorHandler);
  state.client = new Faye.Client(settings.fayeServer);
  state.client.disable('websocket');
  state.client.subscribe(`/${map_session}`, function (message) {
    if (typeof message.message !== 'undefined') message = message.message;
    if (message == 'all saved') {
      state.savedFeatures.forEach(value => {
        state.currentFeature = value;
        state.currentFeature.attributes.progress = 'sent';
      });
      $('.saved-poly').css('background-color', colors.midgrey);
    }
    if (message == 'gettitles') {
      createFinalCall();
    }
  });
  state.client.subscribe(`/report-${map_session}`, data => {
    const { message, value, url } = data;
    if (message === 'pdf-error') {
      state.snapshotProgress = 0;
      state.snapshotLayerCount = 0;
      $('#snapshot_progress').addClass('ready');
      $('#snapshot_progress_text').hide();
      $('#snapshot_progress_close').show();
      $('#snapshot_progress_shrink').hide();
      $('#snap_prog').html(
        `<p style='margin-top: 20px;'>There has been a problem creating your Data Snapshot.</p><p>Please contact the Support Team on 0800 240 4746 quoting:\n Snapshot Data Error: ${value}</p>`,
      );
      $('#snapshot_progress_close')
        .off()
        .click(() => {
          $('#snapshot_progress').hide();
        });
    }
    if (message === 'pdf-ready') {
      $('#snapshot_progress').addClass('ready');
      $('#snapshot_progress_icon').show();
      $('#snapshot_progress_text').hide();
      $('#snap_prog').html(
        `<div style="text-align:center"><p>Please download and save your report</p><p>The report will also be saved in your order history within the Search Acumen website</p><p class="orange">NEW - Interactive Data Snapshot</p><p>A unique and sharable webpage for your Data Snapshot Report. Interact with the data layers, giving you greater flexibility and customisation, including adding notes.</p></div><a class="download_button" href="#" onclick="window.downloadFile('/files/${value}','DS-${state.snapsAddressString.replace(
          /'/g,
          '',
        )}.pdf')">Download Report</a><a class="download_button" href="${url}" target="_blank">Launch Interactive DS</a>`,
      );
      $('#snapshot_progress_close')
        .off()
        .click(() => {
          $('#snapshot_progress').hide();
          activateTool(null, 'pan');
        });
      // $('.download_button')
      //   .off()
      //   .click(() => {
      //     $('#snapshot_progress').hide();
      //   });
    }
    if (message === 'layer-done') {
      $('#snap_prog').html(`<p>${value}</p>`);
      state.snapshotProgress++;
      $('#snapshot_progress_icon').hide();
      $('#snapshot_progress_text')
        .html(
          `${
            state.snapshotProgress <= state.snapshotLayerCount
              ? parseInt((state.snapshotProgress / state.snapshotLayerCount) * 100)
              : 99
          }%`,
        )
        .show();
    }
    if (message === 'layer-count') {
      state.snapshotLayerCount = value;
      $('#snapshot_progress_text').html('0%').show();
    }
  });
  EventBroker.subscribe('getTitleFromPointResult', showLRBoundary);
  EventBroker.subscribe('getAddressInPolyResult', e => populateAddress(e, true));
  EventBroker.subscribe('getAddressResult', e => populateAddress(e, false));
  EventBroker.subscribe('getIntersectsResult', populateIntersects);
  $('.panel, #snaps_choice').drags({
    handle: '.dragbar',
  });
  $('#toolbar').draggable({
    containment: '#map',
    handle: '.dragbar',
    refreshPositions: true,
  });
  $('#sv-control').draggable({
    revert: true,
    start: function () {
      state.sv_dragged = true;
    },
    stop: function (event, ui) {
      $('#pano').show();
      const newx = ui.offset.left;
      const newy = ui.offset.top;
      const lonlat = ol.map.getLonLatFromViewPortPx(new OpenLayers.Pixel(newx - 215, newy));
      const conv = new GT_OSGB();
      conv.setGridCoordinates(lonlat.lon, lonlat.lat);
      const wgs = conv.getWGS84();
      state.panorama = new google.maps.StreetViewPanorama(document.getElementById('pano'), {
        position: {
          lat: wgs.latitude,
          lng: wgs.longitude,
        },
        pov: {
          heading: 0,
          pitch: 10,
        },
        fullscreenControl: true,
        enableCloseButton: true,
        zoomControl: false,
        addressControl: true,
        imageDateControl: true,
      });
      $('#sv-control').css('opacity', '0.9');
      $('#pano').show();
      state.panorama.addListener('position_changed', function () {
        const pos = state.panorama.getPosition();
        const conv = new GT_WGS84();
        conv.setDegrees(pos.lat(), pos.lng());
        const xy2 = conv.getOSGB();
        ol.map.setCenter(new OpenLayers.LonLat(xy2.eastings, xy2.northings));
        moveMarker(xy2);
      });
    },
  });

  $('#info-panel .remove').click(removeFeature);
  $('.ok').click(function () {
    $('#wms-info-panel').hide();
  });
  $('#info-panel .cancel').click(function () {
    closeInfo({ state, ol, featClick, setCursor, activateSelect });
    $('#output').empty();
  });
  $('#info-panel .save').click(saveFeature);
  $('#info-panel .intersects').click(function () {
    state.noDup = true;
    getIntersects();
  });
  $('#info-panel .saveall').click(saveFeatures);
  $('#info-panel .removeall').click(removeFeatures);
  $('#order').click(function () {
    html2canvas(document.getElementById('body'), {
      useCORS: true,
      onrendered: function (canvas) {
        const img = canvas.toDataURL('image/png');
        window.open(img);
      },
    });
  });
  $('.helpSub .helpTitle').click(function () {
    $('#help-panel').show();
    $('.helpPanel').hide();
  });
  $('.helpSub .back').click(() => {
    $('.helpSub').hide();
    $('.help-panel').hide();
    $('#helpPanel').show();
  });
  $('#help-panel .back').click(() => {
    $('#help-panel').hide();
    $(`#helpPanel${state.helpID}`).show();
  });
  $('.helpSub .ok, #helpPanel .ok').click(() => {
    $('.helpSub').hide();
    $('#helpPanel').hide();
  });
  $('#help-panel .ok').click(function () {
    $('#help-panel').hide();
  });
  $('.help').click(function () {
    if ($('#helpPanel').is(':visible')) {
      $('.helpPanel').hide();
    } else {
      $('#helpPanel').show();
    }
  });
}
function populateHelp(type, idx = '') {
  state.helpID = idx;
  $('#help-panel').show();
  $('.helpPanel').hide();
  $('#help-panel .title').html(help[type].title);
  $('#help-panel .message').empty();
  let content = '';
  help[type].content.forEach(h => {
    content += h;
  });
  $('#help-panel .message').html(content);
}
function showHideSV() {
  if (state.sv_dragged) state.sv_dragged = false;
  const vis = $('#pano').is(':visible');
  if (vis) {
    $('#sv-control').css('opacity', '0.5');
    $('#pano').hide();
    ol.points.markerSV.style.display = 'none';
    ol.layers.vectorPin.redraw();
  } else {
    $('#sv-control').css('opacity', '0.9');
    ol.points.markerSV.style.display = 'block';
    ol.layers.vectorPin.redraw();
    $('#pano').show();
    const conv = new GT_OSGB();
    conv.setGridCoordinates(state.initx, state.inity);
    const wgs = conv.getWGS84();
    state.panorama = new google.maps.StreetViewPanorama(document.getElementById('pano'), {
      position: {
        lat: wgs.latitude,
        lng: wgs.longitude,
      },
      pov: {
        heading: 0,
        pitch: 10,
      },
      addressControl: true,
      fullscreenControl: true,
      imageDateControl: true,
    });
    state.panorama.addListener('position_changed', function () {
      const pos = state.panorama.getPosition();
      const conv = new GT_WGS84();
      conv.setDegrees(pos.lat(), pos.lng());
      const xy2 = conv.getOSGB();
      ol.map.setCenter(new OpenLayers.LonLat(xy2.eastings, xy2.northings));
      moveMarker(xy2);
    });
  }
}
function populateIntersects(e, switchMode = true) {
  if (e.special && (e.special.fromDSR || e.special.fromSearch)) state.noInfoPopup = true;
  $('#processing').hide();
  state.getting = false;
  state.siteBusy = false;
  setCursor({ type: state.currentCursor });
  const callingObj = e.callingObj;
  let newFeat = [];
  let ses = JSON.parse(e.response);
  const geojson = new OpenLayers.Format.GeoJSON();
  if (!Array.isArray(ses) && ses.error) {
    if (ses.error == 'intersect error') {
      showError({
        state,
        title: '<center>Data Error Message</center>',
        message: messages.dataError,
      });
    } else {
      if (state.snapsActive) {
        showError({
          state,
          title: '<center>Data Snapshot Limit Exceeded</center>',
          message: messages.snapshotLimit,
        });
      } else {
        showError({
          state,
          title: '<center>Limit Exceeded</center>',
          messgage: messages.orderLimit,
        });
      }
    }
  } else if (ses.length === 0 && state.snapsActive) {
    $('#check_lr, #div_lr').addClass('disabled');
  } else {
    let n = 0;
    ses.forEach(s => {
      let feat;
      if (typeof s.polygon !== 'undefined') feat = geojson.read(s.polygon);
      else feat = geojson.read(s);
      let found = false;
      ol.layers.vector.features.forEach(f => {
        if (f.attributes.title_no == s.title) {
          found = true;
          if (!state.snapsActive) {
            let dup = false;
            state.clickedFeatures.forEach(c => {
              if (c.attributes.title_no == s.title) {
                dup = true;
              }
            });
            if (!dup) newFeat.push([f]);
          }
          if (state.noInfoPopup) {
            if (f.attributes.progress !== 'sent') f.attributes.progress = 'saved';
          }
        }
      });
      if (!found || !state.noDup) {
        feat[0].featType = callingObj.type;
        if (typeof s.geometry === 'undefined' || s.geometry.type != 'Point') {
          setupFeature(feat, s, n, found);
          newFeat.push(feat);
        }
      }
      n++;
    });
    state.noDup = false;
    if (state.snapsActive || state.noInfoPopup) {
      newFeat.forEach(nf => {
        if (nf[0].attributes) nf[0].attributes.progress = 'saved';
        state.clickedFeatures.push(nf[0]);
      });
      setTimeout(() => saveFeatures(), 2000);
      state.noInfoPopup = false;
    } else {
      repopulateInfoBox({ newFeat, state, ol });
    }
    if (e.special && e.special.fromSearch) {
      if (state.clickedFeatures.length) {
        let newExtent = [
          Number.POSITIVE_INFINITY,
          Number.POSITIVE_INFINITY,
          Number.NEGATIVE_INFINITY,
          Number.NEGATIVE_INFINITY,
        ];
        state.clickedFeatures.forEach(f => {
          const bounds = f.geometry.bounds;
          if (bounds) {
            if (bounds.left < newExtent[0]) newExtent[0] = bounds.left;
            if (bounds.bottom < newExtent[1]) newExtent[1] = bounds.bottom;
            if (bounds.right > newExtent[2]) newExtent[2] = bounds.right;
            if (bounds.top > newExtent[3]) newExtent[3] = bounds.top;
          }
        });
        setRestricted(null);
        const newZoom = ol.map.getZoomForExtent(
          new OpenLayers.Bounds(newExtent[0], newExtent[1], newExtent[2], newExtent[3]),
        );
        const newCenter = [
          newExtent[0] + (newExtent[2] - newExtent[0]) / 2,
          newExtent[1] + (newExtent[3] - newExtent[1]) / 2,
        ];
        const c = new OpenLayers.LonLat(newCenter[0], newCenter[1]);
        ol.map.setCenter(c);
        if (newZoom < 10) setRestricted(new OpenLayers.Bounds(c.lon - 5162, c.lat - 5162, c.lon + 5162, c.lat + 5162));
        else setRestricted(null);
        if (newZoom !== ol.map.getZoom()) ol.map.zoomTo(newZoom > 12 ? 12 : newZoom);
      } else {
        showError({
          state,
          title: 'No Search Results',
          message: messages.noSearch,
        });
      }
    }
  }
  state.polysearch = null;
  if (!state.snapsActive && switchMode) activateTool(null, 'pan');
}
function populateAddress(e, stripfirst) {
  if (e.response == '') {
    e.response = '{}';
  }
  const obj = typeof e.response === 'string' ? JSON.parse(e.response) : e.response;
  if (typeof obj.uprn !== 'undefined') {
    obj.address = buildAddress(obj, stripfirst);
    obj.add_source = 'OS AddressBase Premium';
    obj.add_source_descr = 'Accurate address location';
  }
  if (typeof obj.address === 'undefined') {
    $('.item_desc').hide();
    geocode();
  } else {
    if (!obj.primary_desc) {
      $('.item_desc').hide();
    } else {
      $('.item_desc').show();
      if (!obj.current_occupier) $('.current_occ').hide();
      else $('.current_occ').show();
    }
    $.each(obj, function (key, data) {
      if (!data) data = '-';
      if (key !== 'uprn') {
        $(`#attr_${key}`).text(data);
        state.currentFeature.attributes[key] = data;
      } else {
        if (state.currentFeature.attributes.uprn === '' && (obj.unique || !stripfirst)) {
          $(`#attr_${key}`).text(data);
          state.currentFeature.attributes[key] = data;
        }
      }
      if (state.currentFeature.attributes.uprn === '' && obj.uprn !== '') {
        $('#attr_uprn').text(obj.uprn);
        state.currentFeature.attributes.uprn = obj.uprn;
      }
    });
  }
  const mod = $('#snaps-button').is(':hidden') ? 200 : 170;
  $('#info-panel').height($('#info-panel .content').height() + mod);
}

// function isCoalChecked() {
//   return $('#coal1')[0].checked || $('#coal2')[0].checked || $('#coal3')[0].checked;
// }

function addRemoveInfo(e, type) {
  state.queryActive = $('#info-layer-switch').prop('checked');
  if ($('#info-layer-switch').prop('checked') && !type) {
    $('.tool-butt').removeClass('active');
    $('.tool-butt').children().removeClass('active');
    $('#color-box').hide();

    if (ol.controls.wfsInfo2) {
      ol.controls.wfsInfo2.activate();
      ol.controls.wfsInfo2.handlers['feature'].stopDown = false;
      ol.controls.wfsInfo2.handlers['feature'].stopUp = false;
      ol.controls.wfsInfo2.layers.forEach(l => {
        l.events.fallThrough = true;
      });
    }
    ol.controls.wmsInfo2.activate();
    ol.controls.wmsInfo3.activate();
    ol.layers.planningLayer.events.un({
      featureclick: planningclick,
    });
    ol.layers.planningLayer.events.on({
      featureclick: planningclick,
    });
    ol.layers.lineSearchLayer.events.un({
      featureclick: lineSearchclick,
    });
    ol.layers.lineSearchLayer.events.on({
      featureclick: lineSearchclick,
    });
    ol.controls.click.deactivate();
    ol.controls.addPath.deactivate();
    ol.controls.addPoly.deactivate();
    ol.controls.polyTitle.deactivate();
    setCursor({ type: 'help' });
  } else {
    if (!ol.arrays.queryLayers.length) {
      ol.controls.wmsInfo2.deactivate();
      ol.controls.wmsInfo3.deactivate();
      if (ol.controls.wfsInfo2) ol.controls.wfsInfo2.deactivate();
    }

    if (!type) {
      ol.layers.planningLayer.events.un({
        featureclick: planningclick,
      });
      ol.layers.lineSearchLayer.events.un({
        featureclick: lineSearchclick,
      });
      if (state.lastMode) activateTool(true, state.lastMode);
      setCursor({ type: 'default' });
      if ($('#pan-control').parent().hasClass('active')) activatePan();
      if ($('#boundary-control').parent().hasClass('active')) activateTitle();
      if ($('#polygon-control').parent().hasClass('active')) activatePoly();
    } else {
      setCursor({ type: 'crosshair' });
      clearEvents();
      state.drawActive = false;
      type === 'planning' ? (state.planningActive = true) : (state.lineSearchActive = true);
      if (ol.layers.vector.features.length === 1 && ol.layers.vector2.features.length !== 1) {
        if (ol.layers.vector.features[0].geometry.components.length == 1) {
          let cmp = ol.layers.vector.features[0].geometry;
          if (cmp.id.indexOf('Polygon') > -1) {
            cmp = cmp.components[0];
          }
          if (type === 'planning') {
            state.planningFeat = cmp;
            setCursor({ type: 'progress' });
            getInsight({ state, styles, ol });
          } else {
            state.lineSearchFeat = cmp;
            setCursor({ type: 'progress' });
            getLineSearch({ state, styles, ol });
          }
        } else {
          setClicks();
        }
      } else if (ol.layers.vector2.features.length == 1 && ol.layers.vector.features.length === 0) {
        if (type === 'planning') {
          state.planningFeat = ol.layers.vector2.features[0].geometry;
          setCursor({ type: 'progress' });
          getInsight({ state, styles, ol });
        } else if (type === 'lineSearch') {
          state.lineSearchFeat = ol.layers.vector2.features[0].geometry;
          setCursor({ type: 'progress' });
          getLineSearch({ state, styles, ol });
        }
      } else {
        setClicks();
      }
      $('#info-layer-switch').prop('checked', true);
    }
    $('#wms-info-panel').hide();
  }
  if (
    e &&
    (e.currentTarget.dataset.layer === 'Abandoned.Mines.Catalogue' ||
      e.currentTarget.dataset.layer === 'Mine.Entry' ||
      e.currentTarget.dataset.layer === 'Development.High.Risk.Area') &&
    e.currentTarget.checked
  ) {
    if (ol.map.getZoom() >= 7) setTimeout(() => ol.map.zoomTo(7), 200);
  }
}

function updateSavedFeature(feat) {
  state.currentFeature = feat;
  let newDiv;
  state.currentFeature.guid = createguid();
  state.savedFeatures.push(state.currentFeature);
  let address, addr;
  const attr = state.currentFeature.attributes;
  if (typeof attr.address !== 'undefined') {
    addr = attr.address.split(',');
    address = addr[0];
  } else address = '-';
  if (attr.progress == 'sent') {
    newDiv = `<div data-lrtitle='${attr.title_no}' class='saved-poly' style='background-color:#a0a0a0'><div class='label'>Title No.</div><div class='value'>${attr.title_no}</div><div class='label'>Address.</div><div class='value'>${address}</div></div>`;
  } else {
    attr.progress = 'saved';
    newDiv = `<div data-lrtitle='${attr.title_no}' class='saved-poly'><img src='assets/img/bin.png' class='bin' onclick='window.removeSaved("${attr.title_no}")' /><div class='label'>Title No.</div><div class='value'>${attr.title_no}</div><div class='label'>Address.</div><div class='value'>${address}</div></div>`;
  }
  $('.top-row').append(newDiv);
  $('.saved-poly').off();
  $('.saved-poly').click(savedPolyHandler);
  $('#title-count').text(`(${state.savedFeatures.length.toString()})`);
  downloadTitlesCheck();
}

function removeFeatures() {
  state.clickedFeatures.forEach(val => {
    state.currentFeature = val;
    removeFeature();
  });
  state.multiTitle && closeInfo({ state, ol, featClick, setCursor, activateSelect });
  $('#pan-control').click();
}

function removeFeature() {
  const attr = state.currentFeature.attributes;
  setCursor({ type: 'default' });
  if ($('#pan-control').hasClass('active')) ol.controls.click.activate();
  const rem = ol.layers.vector.features.filter(function (feat) {
    return feat.attributes.title_no === attr.title_no;
  });
  ol.layers.vector.removeFeatures(rem);
  const rem2 = state.savedFeatures.filter(function (feat) {
    return feat.attributes.title_no === attr.title_no;
  });
  const index = rem2.length > 0 ? state.savedFeatures.indexOf(rem2[0]) : -1;
  if (index > -1) {
    state.savedFeatures.splice(index, 1);
    $('.saved-poly')
      .filter(function () {
        return $(this).data('lrtitle') === attr.title_no;
      })
      .remove();
  }
  storeSession();
  if (!state.multiTitle) {
    closeInfo({ state, ol, featClick, setCursor, activateSelect });
  } else {
    clearTempMarkup(ol.layers.tempMarkup);
    ol.layers.vector.redraw();
    ol.layers.tempMarkup.redraw();
    $(`#multititle option[value='${attr.title_no}']`).remove();
    if ($('#multititle option').length > 0) {
      $('#multititle').prop('selectedIndex', 0);
      $('#selcount').text($('#multititle option').length.toString());
      state.clickedFeatures = state.clickedFeatures.filter(function (e) {
        return e.attributes.title_no !== attr.title_no;
      });
      $('#multititle').change();
    } else {
      closeInfo({ state, ol, featClick, setCursor, activateSelect });
    }
  }
  if (state.overcount === 0) {
    if (!state.queryActive && !state.infoActive) {
      $('#output').empty();
      setCursor({ type: 'default' });
      if ($('#pan-control').hasClass('active')) ol.controls.click.activate();
    }
  }
  $('#output').empty();
  $('.saved-poly').off();
  $('.saved-poly').click(savedPolyHandler);
  $('#title-count').text(`(${state.savedFeatures.length.toString()})`);
  downloadTitlesCheck();
  $('.sidebar').width(0).width(250);
}

function savedPolyHandler(e) {
  !state.multiTitle && closeInfo({ state, ol, featClick, setCursor, activateSelect });
  $('.saved-poly').removeClass('orangeBG');
  $(e.currentTarget).addClass('orangeBG');
  const title = $(e.currentTarget).data('lrtitle');
  for (let i = 0; i < state.savedFeatures.length; i++) {
    state.currentFeature = state.savedFeatures[i];
    if (state.currentFeature.attributes.title_no == title) {
      state.overcount = 1;
      state.clickedFeatures = [];
      state.clickedFeatures.push(state.currentFeature);
      infoPanelSetup({ state, ol, styles });
    }
  }
}

function removeSaved(title_tbd) {
  let idx = -1;
  state.savedFeatures.forEach((feature, index) => {
    if (feature.attributes.title_no == title_tbd) {
      idx = index;
      state.currentFeature = feature;
    }
  });
  if (idx > -1) {
    state.savedFeatures[idx].attributes.progress = '';
    state.savedFeatures.splice(idx, 1);
    $('.saved-poly')
      .filter(function () {
        return $(this).data('lrtitle') == title_tbd;
      })
      .remove();
    storeSession();
  }
  removeFeature();
}

function titleSearch(feature, switchToPan) {
  removeMatching();
  if (switchToPan) activateTool(null, 'pan');
  else {
    state.polysearchModified = true;
    state.polysearchSelected = null;
  }
  let poly = feature.geometry.components[0].components;
  if (typeof poly[0].components !== 'undefined') {
    poly = poly[0].components;
  }
  let str = '(';
  for (let i = 0; i < poly.length; i++) {
    str += `${poly[i].x.toString()} ${poly[i].y.toString()},`;
  }
  str = `${str.substring(0, str.length - 1)})`;
  state.polysearch = createguid();
  state.clickedFeatures = [];
  ServiceCalls.callService('getIntersects', {
    poly: str,
    buffer: 0,
    type: 'titleSearch',
  });

  feature.style = styles.augment({ ...styles.defaultStyle }, state.currentColor, 2, 0.2);
  feature.type = 'annotation';
  feature.polysearch = state.polysearch;
  ol.layers.vector2.redraw();
  state.annotation = feature;
}

async function getIntersects(infeat, fromDSR = false) {
  let feat = infeat ? infeat : state.clickedFeature;
  busyPointer();
  if (!state.snapsActive) {
    $('#processing').show();
    state.siteBusy = true;
  }
  let poly;
  let outString = '';
  const geojson = new OpenLayers.Format.GeoJSON();
  let json = JSON.parse(geojson.write(feat.geometry));
  json.crs = {
    type: 'name',
    properties: { name: 'urn:ogc:def:crs:EPSG::27700' },
  };
  json = JSON.stringify(json);
  feat.geometry.components.forEach(cmp => {
    poly = cmp.components;
    if (typeof poly[0].components !== 'undefined') {
      poly = poly[0].components;
    }
    outString = `${outString}((${poly.map(pt => `${pt.x.toString()} ${pt.y.toString()}`).join(',')})),`;
  });
  outString = outString.substring(0, outString.length - 1);
  let isError = false;
  if (fromDSR) {
    state.parcelCount = parseInt(await ServiceCalls.getParcels({ poly: outString }));
    if (state.parcelCount > 300) {
      isError = true;
    }
  }
  if (!isError) {
    ServiceCalls.callService(
      'getIntersects',
      {
        poly: outString,
        json: json,
        buffer: 2,
        type: 'boundary',
        snaps: state.snapsActive,
      },
      { fromDSR },
    );
  }
  if (fromDSR) {
    if (isError)
      showError({
        state,
        title: 'Data Snapshot Boundary Error',
        message: messages.tooLarge,
      });
    else continueSnapshot();
  }
}

function saveFeatures() {
  state.clickedFeatures.forEach(val => {
    state.currentFeature = val;
    saveFeature();
  });
  state.multiTitle && closeInfo({ state, ol, featClick, setCursor, activateSelect });
}

function saveFeature() {
  let bFound = false;
  let cf = state.currentFeature;
  let attr = cf.attributes;
  state.savedFeatures.forEach(value => {
    if (value.attributes.title_no == attr.title_no) {
      bFound = true;
    }
  });
  if (!bFound) {
    cf.guid = createguid();
    state.savedFeatures.push(cf);
    const address = typeof attr.address !== 'undefined' ? attr.address.split(',')[0] : '-';
    attr.progress = 'saved';
    const newDiv = createSavedCard({ attr, address });
    $('.top-row').append(newDiv);
    if (state.timer) {
      clearTimeout(state.timer);
      state.timer = null;
    }
    storeSession();
  }
  !state.multiTitle && closeInfo({ state, ol, featClick, setCursor, activateSelect });

  $('#output').empty();
  $('#title-count').text(`(${state.savedFeatures.length.toString()})`);
  downloadTitlesCheck();
  $('.saved-poly').off().click(savedPolyHandler);
}
const downloadTitlesCheck = () => {
  if (state.savedFeatures.length) {
    $('#downloadSaved').removeClass('disabled');
    $('[data-toggle="tooltip"]').tooltip({ html: true });
  } else {
    $('#downloadSaved').addClass('disabled');
  }
  const count = Math.min(Math.max(state.savedFeatures.length, 0), 2);
  const h = `${80 + 45 * count}px`;
  $('#layer-list').css('max-height', `calc(100% - ${h})`);
};

function errorHandler(message) {
  showError({ state, title: 'Error', message });
}

function onloadstart() {
  console.log('loadStart');
  const zLevel = ol.map.getZoom();
  if (zLevel == 12 && ol.map.getLayerIndex(ol.layers.wfs) == -1) {
    ol.map.addLayer(ol.layers.wfs);
    ol.controls.snap.activate();
  }

  if (state.sendImageTimeout) {
    clearTimeout(state.sendImageTimeout);
    state.sendImageTimeout = null;
  }
  const target = document.getElementById('map');
  state.loadcount++;
  if (!state.spinner && state.loadcount === 1) {
    state.spinner = new Spinner().spin();
    target.appendChild(state.spinner.el);
  }
}

function onloadend() {
  console.log('loadEnd');
  state.loadcount--;
  checkLineWidth();
  if (state.spinner && state.loadcount < 1) {
    const zLevel = ol.map.getZoom();
    if (zLevel == 11 && ol.map.getLayerIndex(ol.layers.wfs) !== -1) {
      ol.map.removeLayer(ol.layers.wfs);
      ol.controls.snap.deactivate();
    }
    state.spinner.stop();
    state.spinner = null;
  }
  if ($('#info-layer-switch').prop('checked')) {
    setCursor({ type: 'help' });
  }
}

function saveOverlay(layer) {
  ServiceCalls.callService('saveoverlay', {
    screenarea: ol.map.getExtent().toGeometry().toString(),
    guid: guid,
    layer: layer,
  });
}

function sendImage() {
  ServiceCalls.callService('saveArea', { screenarea: ol.map.getExtent().toGeometry().toString(), guid: guid });
  state.frozen = true;
  state.client = new Faye.Client(settings.fayeServer);
  state.client.disable('websocket');
  state.client.subscribe(`/finalcall-${map_session}`, message => {
    $('#processing').hide();
    state.siteBusy = false;
    console.log(message);
  });
  state.client.subscribe(`/finalcall-${map_session}-recieved`, function (message) {
    if (!message.success && !message.Success) {
      showError({
        state,
        title: 'Progress Error',
        message: messages.progressError,
        callback: function () {
          location.reload();
        },
      });
      $('#blocker').hide();
      cancelBoundary();
    }
  });
  const finalObj = {
    sessionid: guid,
  };
  const {
    finalCentroid,
    combinedJSONString,
    finalJSONString,
    finalWKT,
    finalArea,
    uncleanJSONString,
    separate,
    confirmed_address,
  } = state;
  if (state.usePlan) {
    finalObj.json = JSON.stringify({
      sessionId: guid,
      useUploadedPlan: state.usePlan.toString(),
      combinedPoly: { centroid: { x: finalCentroid.x, y: finalCentroid.y } },
      searchAddress: confirmed_address,
    });
  } else {
    finalObj.json = JSON.stringify({
      wkt: finalWKT.replace(/ /g, '_'),
      sessionId: guid,
      useUploadedPlan: state.usePlan.toString(),
      combinedPoly: { geometry: JSON.parse(finalJSONString), centroid: { x: finalCentroid.x, y: finalCentroid.y } },
      uncleanPoly: uncleanJSONString,
      cleanPoly: combinedJSONString,
      searchAddress: confirmed_address,
      separate,
      area: finalArea,
    });
  }
  $('#processing').show();
  state.siteBusy = true;
  ServiceCalls.callService('finalcall', finalObj);
  state.lastMode = 'Complete';
}
function filterLayer() {}
const wfsFeatureSelect = e => {
  if (!state.wfsTimer) {
    state.wfsTimer = setTimeout(() => {
      state.wfsTimer = null;
      e.xy = ol.controls.wfsInfo2.handlers.feature.evt.xy;
      const latlon = ol.map.getLonLatFromViewPortPx(e.xy);
      const point = new OpenLayers.Geometry.Point(latlon.lon, latlon.lat);
      const geojson = new OpenLayers.Format.GeoJSON();
      let feat = [];
      ol.arrays.addedWFSOlLayers.forEach(l => {
        if (l.features) {
          l.features.forEach(o => {
            let components;
            if (o.geometry.CLASS_NAME === 'OpenLayers.Geometry.Point') {
              const xdist = Math.abs(point.x - o.geometry.x);
              const ydist = Math.abs(point.y - o.geometry.y);
              if ((xdist < 5) & (ydist < 5)) {
                o.attributes.fsProxy = l.proxy;
                feat.push(o);
              }
            } else {
              if (o.geometry.CLASS_NAME === 'OpenLayers.Geometry.Polygon') {
                components = [o.geometry];
              } else {
                components = o.geometry.components;
              }
              components.forEach(c => {
                const contains = c.containsPoint(point);
                if (contains) {
                  o.attributes.fsProxy = l.proxy;
                  feat.push(o);
                }
              });
            }
          });
        }
      });
      if (feat.length) {
        e.text = geojson.write(feat);
        e.fromWFS = true;
        if (state.hasProxy) {
          ol.controls.wmsInfo3.getInfoForClick(e);
        }
        if (state.hasFind) ol.controls.wmsInfo2.getInfoForClick(e);
        showWMSInfo({ evt: e, state, ol, settings });
        ol.controls.wfsInfo2.unselect(e.feature);
      }
    }, 500);
  }
};
function addRemoveLayer(e) {
  if (this) {
    const datalayer = $(this).data('layer').toString().split(',');
    if (settings.alternateLayers[datalayer[0]]) {
      datalayer[0] = settings.alternateLayers[datalayer[0]];
    }
    const layer = datalayer.map(d => settings.layerprefix + d).join(',');
    const wfs = $(this).data('wfs');
    const query = $(this).data('query');
    let layerstoadd = [];
    if (wfs && layer.includes(',')) layerstoadd = layer.split(',');
    else layerstoadd = [layer];
    layerstoadd.forEach((layer, lidx) => {
      if ($(this).data('layertype') == 'overlay') {
        if (this.checked) {
          if (datalayer == 'vw_landreg_titles_address_lookup' && !$(this).data('filter')) {
            $('.sublayercb').each(function () {
              if (!$(this).prop('checked')) {
                $(this).click();
              }
            });
            return;
          } else if (datalayer == 'planning') {
            addPlanning({ state, addRemoveInfo });
            return;
          } else if (datalayer == 'lineSearch') {
            addLinesearch({ state, addRemoveInfo });
            return;
          }
          saveOverlay(layer);
          if (this.id !== 'title_numbers') {
            if (!wfs) ol.arrays.addedLayers.push(layer + ($(this).data('filter') ? '-' + $(this).data('filter') : ''));
            else ol.arrays.addedWFSLayers.push(layer + ($(this).data('filter') ? '-' + $(this).data('filter') : ''));
          }
          var lserver = settings.layerServer;
          const p = $(this).data('proxy') ? $(this).data('proxy').toString() : null;
          if (p) {
            lserver = settings.layerProxy + '/' + p.split(',')[lidx];
            if ($(this).data('wfs')) state.hasWFS++;
            else state.hasProxy++;
          } else if ($(this).data('server') == 2) {
            lserver = settings.layerServer2;
            state.hasFind++;
          }
          let newLayer;
          const ops = { layer, lserver, ol };
          if (wfs) {
            newLayer = addNewWFS({
              ...ops,
              state,
              p,
              colors,
              styles,
              geometryName: $(this).data('geom').split(',')[0],
              outputFormat: $(this).data('outputformat') || null,
            });
          } else {
            newLayer = addNewWMS({
              ...ops,
              opacity: parseFloat($(this).data('opacity')),
              singleTile: $(this).data('single'),
            });
          }
          if ($(this).data('filter')) {
            newLayer.params.cql_filter = `class_of_title_code IN (${util.titlefilters[$(this).data('filter')]})`;
          }
          if (ol.layers.filtlayer) {
            ol.map.removeLayer(ol.layers.filtlayer);
            ol.layers.filtlayer = null;
          }
          let filt = '';
          $('.lrcheck').each(function () {
            if (this.checked && $(this).data('filter')) {
              filt += `${util.titlefilters[$(this).data('filter')]},`;
            }
            if (this.id === 'title_numbers' && this.checked) state.titlesOn = true;
          });
          if (this.id === 'title_numbers' && this.checked) {
            if (filt == '') {
              $('.landregmaster').click();
            }
          }

          filt = filt.replace(/(^,)|(,$)/g, '');
          if (filt && state.titlesOn) {
            ol.layers.filtlayer = new OpenLayers.Layer.WMS(
              'vw_lu_landreg_titles_number',
              settings.layerServer2,
              {
                layers: 'vw_lu_landreg_titles_number',
                transparent: true,
                cleanup: 1,
              },
              {
                format: 'image/png',
                isBaseLayer: false,
                projection: ol.osgb,
                fallThrough: true,
                maxExtent: [0, 0, 1400000, 1600000],
                opacity: 1,
                singleTile: true,
                wrapDateLine: false,
                transitionEffect: 'resize',
              },
            );
            ol.layers.filtlayer.params.cql_filter = `class_of_title_code IN (${filt})`;
          }
          newLayer.setZIndex(1004);
          if (!wfs) {
            if (this.id !== 'title_numbers') ol.arrays.addedOlLayers.push(newLayer);
            if (query != 'no') {
              if (this.id !== 'title_numbers') ol.arrays.queryOlLayers.push(newLayer);
              if (this.id !== 'title_numbers') ol.arrays.queryLayers.push(layer);
            }
          }
          if (wfs) {
            ol.arrays.addedWFSOlLayers.push(newLayer);
          }
          ol.map.removeLayer(ol.layers.vector);
          ol.map.removeLayer(ol.layers.vector2);
          if (this.id !== 'title_numbers')
            newLayer.events.register('loadend', newLayer, function () {
              setCursor({ type: 'help' });
            });
          if (ol.layers.filtlayer) {
            ol.layers.filtlayer.events.register('loadend', ol.layers.filtlayer, function () {
              setCursor({ type: 'help' });
            });
            ol.layers.filtlayer.events.fallThrough = true;
          }
          newLayer.events.fallThrough = true;
          if (this.id !== 'title_numbers') ol.map.addLayer(newLayer);
          if (wfs) setupWFS({ ol, newLayer, wfsFeatureSelect });
          if (ol.layers.filtlayer) ol.map.addLayer(ol.layers.filtlayer);
          ol.map.addLayer(ol.layers.vector);
          ol.map.addLayer(ol.layers.vector2);

          const div = newLayer.div;
          if (parseFloat($(this).data('opacity')) != 1) {
            if ($(this).data('blend') && state.currentBM !== 'bwLayer')
              $(div).css('mix-blend-mode', $(this).data('blend'));
            else $(div).css('mix-blend-mode', 'multiply');
          }
        } else {
          if (datalayer == 'vw_landreg_titles_address_lookup' && !$(this).data('filter')) {
            $('.sublayercb').each(function () {
              if ($(this).prop('checked')) {
                $(this).click();
              }
            });
            return;
          } else if (datalayer == 'planning') {
            activateCheckboxes();
            state.planningClicked = false;
            $('#csv-link').hide();
            $('#planning_settings').hide();
            if (ol.arrays.queryLayers.length == 0) {
              $('#info-layer-switch').prop('checked', false);
              addRemoveInfo(null);
            }
            clearInsight({ ol, state });
            return;
          } else if (datalayer == 'lineSearch') {
            activateCheckboxes();
            state.lineSearchClicked = false;
            $('#csv-link').hide();
            $('#lineSearch_settings').hide();
            if (ol.arrays.queryLayers.length == 0) {
              $('#info-layer-switch').prop('checked', false);
              addRemoveInfo(null);
            }
            clearLineSearch({ ol, state });
            return;
          }
          if ($(this).data('server') == 2) {
            state.hasFind--;
          } else if ($(this).data('proxy')) {
            if ($(this).data('wfs')) state.hasWFS--;
            else state.hasProxy--;
          }
          const idx = ol.arrays.addedLayers.indexOf(
            layer + ($(this).data('filter') ? '-' + $(this).data('filter') : ''),
          );
          const idx2 = ol.arrays.queryLayers.indexOf(layer);
          const idx3 = ol.arrays.addedWFSLayers.indexOf(layer);
          if (this.id !== 'title_numbers') {
            if (idx !== -1) {
              const ltr = ol.arrays.addedOlLayers[idx];
              ol.map.removeLayer(ltr);
            }
            if (idx3 !== -1) {
              const wtr = ol.arrays.addedWFSOlLayers[idx3];
              ol.map.removeLayer(wtr);
            }
            if (idx !== -1) {
              ol.arrays.addedLayers.splice(idx, 1);
              ol.arrays.addedOlLayers.splice(idx, 1);
            }
            if (idx2 !== -1) {
              ol.arrays.queryLayers.splice(idx2, 1);
              ol.arrays.queryOlLayers.splice(idx2, 1);
            }
            if (idx3 !== -1) {
              ol.arrays.addedWFSLayers.splice(idx3, 1);
              ol.arrays.addedWFSOlLayers.splice(idx3, 1);
            }
          } else {
            if (ol.layers.filtlayer) {
              ol.map.removeLayer(ol.layers.filtlayer);
              ol.layers.filtlayer = null;
            }
            state.titlesOn = false;
          }
          if (ol.layers.filtlayer) {
            ol.map.removeLayer(ol.layers.filtlayer);
            ol.layers.filtlayer = null;
          }
          let filt = '';
          $('.lrcheck').each(function () {
            if (this.checked && $(this).data('filter')) {
              filt += `${util.titlefilters[$(this).data('filter')]},`;
            }
            if (this.id === 'title_numbers' && this.checked) state.titlesOn = true;
          });
          if (filt === '') {
            if ($('#title_numbers').is(':checked')) {
              state.titleNumbersChecked = true;
              $('#title_numbers').click();
            }
            if ($($('.landregmaster')[0]).is(':checked')) {
              $('.landregmaster').click();
            }
          }
          filt = filt.replace(/(^,)|(,$)/g, '');
          if (filt && state.titlesOn) {
            ol.layers.filtlayer = new OpenLayers.Layer.WMS(
              'vw_lu_landreg_titles_number',
              settings.layerServer2,
              {
                layers: 'vw_lu_landreg_titles_number',
                transparent: true,
                cleanup: 1,
              },
              {
                format: 'image/png',
                isBaseLayer: false,
                projection: ol.osgb,
                fallThrough: true,
                maxExtent: [0, 0, 1400000, 1600000],
                opacity: 1,
                singleTile: true,
                wrapDateLine: false,
                transitionEffect: 'resize',
              },
            );
            ol.layers.filtlayer.params.cql_filter = `class_of_title_code IN (${filt})`;
            ol.map.addLayer(ol.layers.filtlayer);
            ol.layers.filtlayer.events.register('loadend', ol.layers.filtlayer, function () {
              setCursor({ type: 'help' });
            });
          }
        }
      } else if ($(this).data('layertype') == 'basemap') setupBasemap({ state, ol });
      if (!ol.arrays.addedWFSOlLayers.length && ol.controls.wfsInfo2) {
        ol.controls.wfsInfo2.deactivate();
      }
      if (ol.arrays.queryLayers.length || ol.arrays.addedWFSOlLayers.length) {
        if (ol.arrays.queryLayers.length) {
          ol.controls.wmsInfo2.layers = ol.arrays.queryOlLayers;
          ol.controls.wmsInfo3.layers = ol.arrays.queryOlLayers;
        }
        if (ol.arrays.addedWFSOlLayers.length) {
          ol.controls.wfsInfo2.layers = ol.arrays.addedWFSOlLayers;
          ol.controls.wfsInfo2.layers.forEach(l => {
            l.events.fallThrough = true;
          });
        }
        $('#info-layer-switch').prop('checked', true);
        addRemoveInfo(e);
        setCursor({ type: 'help' });
      } else if (!state.planningClicked && !state.lineSearchClicked) {
        $('#info-layer-switch').prop('checked', false);
        addRemoveInfo(e);
      }
      let count = 0;
      $('.sublayercb').each(function () {
        if ($(this).prop('checked')) count++;
      });
      $('.landregmaster').prop('checked', count > 0);
      if (ol.arrays.addedLayers.length || ol.arrays.addedWFSLayers.length) {
        $('.download-image a').css('pointer-events', 'auto');
        $('.download-image a').css('background-color', colors.orange);
        $('.download-image a').css('cursor', 'pointer');
      } else {
        $('.download-image a').css('pointer-events', 'none');
        $('.download-image a').css('background-color', '#909090');
      }
      activateCheckboxes();
      ol.layers.vectorOverview.setZIndex(3000);
    });
  }
}

function getFeaturesGeomJSON(layer, safe, full) {
  if (!safe) safe = false;
  const geojson = new OpenLayers.Format.GeoJSON();
  if (full) return JSON.parse(geojson.write(layer.features[0].geometry));
  else return JSON.parse(geojson.write(layer.features[0].geometry)).coordinates;
}

function getAllFeaturesJSON(feats) {
  const geojson = new OpenLayers.Format.GeoJSON();
  return geojson.write(feats);
}
function getSnapshotJSON() {
  const geojson = new OpenLayers.Format.GeoJSON();
  const json = geojson.write(state.snapshotFeatures);
  const jjson = JSON.parse(json);
  if (jjson.features) {
    jjson.features = jjson.features.filter(function (feat) {
      return feat.geometry.type !== 'Point';
    });
  }
  jjson.features = jjson.features.map(function (feat) {
    if (feat.geometry.type === 'MultiPolygon') {
      feat.geometry.coordinates[0] = feat.geometry.coordinates[0].filter(function (c) {
        return c.length > 2;
      });
      return feat;
    } else return feat;
  });
  jjson.center = ol.map.getCenter();
  return JSON.stringify(jjson);
}

function featureAdded(feature, subtype) {
  feature = cleanPoly(feature);
  $('#undo-redo').hide();
  feature.subtype = subtype;
  let newStyle = {};
  if (subtype == 'property') {
    newStyle = { ...styles.propertyStyle };
    feature.type = 'boundary';
  } else {
    newStyle = { ...styles.defaultStyle };
    feature.type = 'annotation';
  }
  if (subtype != 'property') {
    feature.style = styles.augment(newStyle, state.currentColor, 2, 0);
    feature.type = 'annotation';
  } else {
    $('#identify').show();
    $('.bottom-row').removeClass('disabled');
    state.snapshotFeatures.push(feature);
    let combined = checkConnected(state.snapshotFeatures, false);
    ol.layers.vector2.removeFeatures([feature]);
    ol.layers.vector2.features.forEach(l => {
      l.type === 'property' && ol.layers.vector2.removeFeatures([l]);
    });
    $('#intersect-tool').show();

    if (combined == null || combined == 'MultiPolygon' || combined == 'Polygons') {
      state.snapshotFeatures.shift();
      ol.layers.vector2.addFeatures(state.snapshotFeatures);
      combined = state.snapshotFeatures[0];
    }
    combined.style = styles.augment(newStyle, colors.green, 4, 0);
    combined.type = 'property';
    combined.subtype = 'property';
    ol.layers.vector2.addFeatures([combined]);
    state.snapshotFeatures = [combined];
    if (combined.geometry.getArea() > (settings.maxSnapshot || 100000000)) {
      setArea({ feat: combined, pa: false });
      showError({
        state,
        title: 'Data Snapshot Boundary Error',
        message: messages.tooLarge,
      });
      return;
    } else {
      combined.style = styles.augment(newStyle, colors.green, 4, 0);
      combined.type = 'property';
      combined.subtype = 'property';
      ol.layers.vector2.addFeatures([combined]);
      state.snapshotFeatures = [combined];
      if (combined.geometry.getArea() > (settings.maxSnapshot || 100000000)) {
        setArea({ feat: combined, pa: false });
        showError({
          state,
          title: 'Data Snapshot Boundary Error',
          message: messages.tooLarge,
        });
        return;
      }
    }
  }
  ol.layers.vector2.redraw();
  if (subtype != 'property') activateTool(null, 'select');
  else {
    $('#snapshot-tool').click();
  }
  const crossover = findSelfIntersects(feature);
  ol.layers.error.removeFeatures([ol.points.error]);
  if (crossover && crossover.length) {
    showGeometryError(crossover, false);
    showError({
      state,
      title: 'Progress Error',
      message: messages.crossoverError,
    });
  }
}
function clearEvents() {
  ol.layers.vector2.events.un({
    featureclick: polyClick,
  });
  ol.layers.vector.events.un({
    featureclick: featClick,
  });
}
const disableTools = bool => {
  state.snapsActive = bool;
  if (bool) {
    $('#mapping_toolbar').hide();
    $('#identify_toolbar').hide();
    $('.bottom-row').addClass('disabled');
    $('#confirm-button').hide();
  } else {
    $('#mapping_toolbar').show();
    $('#identify_toolbar').show();
    $('.bottom-row').removeClass('disabled');
    $('#confirm-button').show();
  }
};
const activeSnapshotDraw = () => {
  $('#snaps_choice').hide();
  $('#snapshot_draw_step1').show();
  snaps_draw();
};
function activateTitle() {
  disableTools(true);
  $('#snapshot_progress').hide();
  if (!getCookie('snapshotSeen') && !state.snapshotSeen) {
    $('#blocker').show();
    $('#whatsNew').show();
    state.snapshotSeen = true;
  }
  $('#confirm-button').hide();
  $('#snaps_choice').show();
  if (ol.layers.vector2.features.length > 0 || ol.layers.vector.features.length > 0) {
    $('#use_existing').removeAttr('disabled');
  } else {
    $('#use_existing').attr('disabled', true);
  }
}
function snaps_useExisting() {
  clearEvents();
  state.planningActive = false;
  state.useExisting = true;
  setClicks();
}
function addToSnapshot(e) {
  if (state.snapshotFeatures) ol.layers.vector2.removeFeatures(state.snapshotFeatures);
  let feat;
  if (
    e.feature.geometry.CLASS_NAME === 'OpenLayers.Geometry.MultiPolygon' ||
    e.feature.geometry.components.length > 1
  ) {
    const currentPoint = new OpenLayers.Geometry.Point(state.mousePos.lon, state.mousePos.lat);
    snaploop: for (const p of e.feature.geometry.components.reverse()) {
      if (p.components.length > 1 && p.components[0].components) {
        for (const p2 of p.components) {
          if (p2.containsPoint(currentPoint)) {
            const lr = new OpenLayers.Geometry.LinearRing(p2.components);
            const poly = new OpenLayers.Geometry.Polygon(lr);
            feat = new OpenLayers.Feature.Vector(poly);
            break snaploop;
          }
        }
      } else if (p.containsPoint(currentPoint)) {
        const lr = new OpenLayers.Geometry.LinearRing(
          p.components[0].components ? p.components[0].components : p.components,
        );
        const poly = new OpenLayers.Geometry.Polygon(lr);
        feat = new OpenLayers.Feature.Vector(poly);
        break snaploop;
      }
    }
  } else {
    feat = e.feature.clone();
  }
  if (feat) {
    let newStyle = { ...styles.propertyStyle };
    feat.style = styles.augment(newStyle, colors.green, 4, 0);
    feat.type = 'property';
    feat.subtype = 'property';
    feat.style = newStyle;
    if (!state.snapshotFeatures || state.snapshotFeatures.length === 0) {
      state.snapshotFeatures = [feat];
    } else {
      const union = cascadeUnion([...state.snapshotFeatures, feat], false);
      if (!union.error) {
        const newfeat = new OpenLayers.Feature.Vector(union.poly, null, newStyle);
        newfeat.type = 'property';
        newfeat.subtype = 'property';
        state.snapshotFeatures = [newfeat];
      }
    }
    ol.layers.vector2.addFeatures(state.snapshotFeatures);
  }
}
const convertMulti = f => {
  if (goodSnapshot(f)) return f;
  else if (f[0].geometry.getArea() > (settings.maxSnapshot || 1000000000)) {
    return f;
  } else {
    const cond1 = f.length == 1 && f[0].geometry.CLASS_NAME === 'OpenLayers.Geometry.MultiPolygon';
    const cond2 =
      f.length == 1 &&
      f[0].geometry.CLASS_NAME === 'OpenLayers.Geometry.Polygon' &&
      f[0].geometry.components.length > 1;
    if (cond1 || cond2) {
      if (f[0].geometry.components.length > 1) {
        const comp = f[0].geometry.components;
        let largest = -1;
        let feat;
        comp.forEach(c => {
          if (c.components && c.components.length > largest) {
            if (c.CLASS_NAME.includes('Linear'))
              feat = new OpenLayers.Feature.Vector(new OpenLayers.Geometry.Polygon([c]));
            else feat = new OpenLayers.Feature.Vector(c);
            largest = c.components.length;
          }
        });
        if (state.snapshotFeatures) ol.layers.vector2.removeFeatures(state.snapshotFeatures);
        let newStyle = { ...styles.propertyStyle };
        feat.style = styles.augment(newStyle, colors.green, 4, 0);
        feat.type = 'property';
        feat.subtype = 'property';
        feat.style = newStyle;
        ol.layers.vector2.addFeatures(feat);
        return [feat];
      }
    }
  }
};
const goodSnapshot = f => {
  let isValid =
    !!f &&
    f.length == 1 &&
    f[0].geometry.CLASS_NAME !== 'OpenLayers.Geometry.MultiPolygon' &&
    f[0].geometry.components &&
    f[0].geometry.components.length === 1 &&
    f[0].geometry.getArea() <= (settings.maxSnapshot || 100000000);
  return isValid;
};
function useExistingClick(e) {
  if (e.feature.type !== 'property') {
    addToSnapshot(e);
  } else if (!state.useExistingTimer && e.feature.type === 'property') {
    state.useExistingTimer = setTimeout(() => {
      state.useExistingTimer = null;
    }, 200);
  } else {
    if (e.feature.type === 'property') {
      state.snapshotFeatures = convertMulti(state.snapshotFeatures);
      state.useExistingTimer = null;
      if (goodSnapshot(state.snapshotFeatures)) {
        showSnapshotOrder();
      } else if (state.snapshotFeatures[0].geometry.getArea() > (settings.maxSnapshot || 100000000)) {
        setArea({ feat: state.snapshotFeatures[0], pa: false });
        showError({
          state,
          title: 'Data Snapshot Boundary Error',
          message: messages.tooLarge,
        });
      } else {
        showError({
          state,
          title: 'Data Snapshot Boundary Error',
          message: messages.multi,
        });
      }
    }
  }
}
const cleanupSnapshot = () => {
  $('.sn_layer_list input').prop('checked', false);
  $('.sn_layer_list input').prop('indeterminate', false);
  $('#snapshot_next').attr('disabled', true);
  $('.pill').removeClass('selected');
  $('#warnings').empty();
  $('.fa-minus').click();
  $('#subtotal').text('0');
  state.snapshotLayers = [];
  state.snapshotGroups = [];
  activateTool(null, 'pan');
};

const handleSnapshotLayers = () => {
  $('.snapshot_layer')
    .off()
    .on('change', e => {
      const warning = $(e.currentTarget).data('warning');
      const warningID = `warning-${$(e.currentTarget).data('layer')}`;
      if (warning) {
        const html = `<div style="margin-bottom:10px" id="${warningID}">${warning}</div>`;
        $(`#${warningID}`).remove();
        if (e.currentTarget.checked) $('#warnings').append(html);
      }
      if (!state.pillTimer) $('.pill').removeClass('selected');
      const par = $(e.currentTarget).parent().parent();
      const inputs = par.find('input').parent().not('.hidelayer').add(par.find('input').parent('.hidelayer.show'));
      let count = 0;
      inputs.each((i, item) => {
        if ($(item).find('input').is(':checked')) count++;
      });
      const inp = par.parent().parent().find('input').first();
      const grp = inp.data('group');
      if (count === inputs.length) {
        state.snapshotGroups.push(grp);
        $(inp).prop('checked', true);
        $(inp).prop('indeterminate', false);
      } else {
        state.snapshotGroups = state.snapshotGroups.filter(s => s !== grp);
        $(inp).prop('checked', false);
        $(inp).prop('indeterminate', count !== 0);
      }
      inputs.each((i, item) => {
        const inp = $(item).find('input');
        const l = inp.data('layer');
        const g = inp.data('group');
        if (count == 0 || count === inputs.length) {
          state.snapshotLayers = state.snapshotLayers.filter(s => {
            return s !== `${g}:${l}`;
          });
        } else {
          if (inp.is(':checked')) state.snapshotLayers.push(`${g}:${l}`);
          else
            state.snapshotLayers = state.snapshotLayers.filter(s => {
              return s !== `${g}:${l}`;
            });
        }
      });
      state.snapshotLayers = [...new Set(state.snapshotLayers)];
      state.snapshotGroups = [...new Set(state.snapshotGroups)];
      recalculatePrice(state);
      if (
        state.snapshotGroups.includes('planning') ||
        state.snapshotLayers.filter(s => s.includes('planning_application')).length
      ) {
        $('#check_extended').attr('disabled', false);
      } else {
        $('#check_extended').attr('disabled', true);
        $('#check_extended').prop('checked', false);
      }
      if (state.snapshotGroups.sort().join(' ').replace('extended ', '') === 'flood lr planning transpor    t')
        $('#check_all').addClass('selected');
      else $('#check_all').removeClass('selected');
    });
};

function showSnapshotOrder() {
  setArea({ feat: state.snapshotFeatures[0], pa: false });
  $('#check_lr, #div_lr').removeClass('disabled');
  state.noInfoPopup = true;
  getIntersects(state.snapshotFeatures[0], true);
  $('#snaps_choice, #snapshot_existing_step1, #snapshot_draw_step1').hide();
}

function continueSnapshot() {
  $('#snapshot_report_panel').show();
  ol.controls.modifyFeature.unselectFeature(state.snapshotFeatures[0]);
  const area = state.snapshotFeatures[0].geometry.getArea();
  state.allPrice = calculatePrice({ groups: ['all'], area, parcels: state.parcelCount }).price;
  handleSnapshotLayers();
  $('#snapshot_next')
    .off()
    .on('click', () => {
      $('#snapshot_report_panel').hide();
      snapsAddress();
    });
  $('#snapshot_report_panel .closepanel, #snapshot_cancel')
    .off()
    .click(() => {
      cleanupSnapshot();
      $('#snapshot_report_panel').hide();
      if (state.lastMode) activateTool(true, state.lastMode === 'snapshot' ? 'pan' : state.lastMode);
      disableTools(false);
    });
  $('.pill')
    .not('.snap_all')
    .off()
    .on('click', e => {
      state.pillTimer = setTimeout(() => {
        state.pillTimer = null;
      }, 250);
      $('.snap_cat').prop('checked', false).change();
      $('.snap_cat').prop('indeterminate', false);
      if ($(e.currentTarget).hasClass('selected')) {
        $(e.currentTarget).removeClass('selected');
      } else {
        $(e.currentTarget).addClass('selected');
      }
      $('.pill')
        .not('.snap_all')
        .each((i, p) => {
          if ($(p).hasClass('selected')) {
            const layers = pricing.packs[$(p).data('group')];
            layers.forEach(l => {
              $(`input[data-layer='${l.split(':')[1]}']`).click();
            });
          }
        });
    });
  $('.snap_all')
    .off()
    .on('click', e => {
      state.snapshotGroups = [];
      state.snapshotLayers = [];
      if ($(e.currentTarget).hasClass('selected')) {
        $('.snap_cat').not('.disabled').prop('checked', false).change();
        $('.snap_cat').not('.disabled').prop('indeterminate', false);
      } else {
        $('.snap_cat').not('.disabled').prop('checked', true).change();
        $('.snap_cat').not('.disabled').prop('indeterminate', false);
      }

      if ($('.snap_layercb:checked').length) {
        $('#snapshot_next, #check_extended').removeAttr('disabled');
      } else {
        $('#snapshot_next, #check_extended').attr('disabled', true);
        $('#check_extended').prop('checked', false);
      }
    });
  $('.snap_cat')
    .off()
    .on('click', () => {
      $('.snap_all').prop('checked', $('.snap_cat:checked').length === $('.snap_cat').length);
    });
  $('.snap_layercb')
    .off()
    .on('change', e => {
      const group = $(e.currentTarget).data('group');
      if (!state.pillTimer) $('.pill').removeClass('selected');
      if ($(e.currentTarget)[0].checked) {
        $(e.currentTarget).parent().find('.checkmark').prop('checked', true);
        state.snapshotGroups.push(group);
      } else {
        $(e.currentTarget).parent().find('.checkmark').prop('checked', false);
        state.snapshotGroups = state.snapshotGroups.filter(o => o !== group);
      }
      $(e.currentTarget)
        .parent()
        .find('.checkmark')
        .each(function () {
          const warning = $(this).data('warning');
          const warningID = `warning-${$(this).data('layer')}`;
          if (warning) {
            const html = `<div style="margin-bottom:10px" id="${warningID}">${warning}</div>`;
            $(`#${warningID}`).remove();
            if (this.checked) $('#warnings').append(html);
          }
        });
      state.snapshotLayers = state.snapshotLayers.filter(i => !i.includes(`${group}:`));
      recalculatePrice(state);
      if (state.snapshotGroups.sort().join(' ').replace('extended ', '') === 'flood lr planning transport')
        $('#check_all').addClass('selected');
      if (
        state.snapshotGroups.includes('planning') ||
        state.snapshotLayers.filter(s => s.includes('planning_application')).length
      ) {
        $('#check_extended').attr('disabled', false);
      } else {
        $('#check_extended').attr('disabled', true);
        $('#check_extended').prop('checked', false);
      }
    });
}
function snaps_draw() {
  setCursor({ type: 'crosshair' });
  clearEvents();
  state.planningActive = false;
  state.drawActive = true;
  ol.controls.polyTitle.activate();
}
function activatePoly(showColor = false) {
  if (showColor) $('#color-box').show();
  setCursor({ type: 'crosshair' });
  state.planningActive = false;
  state.drawActive = true;
  ol.controls.addPoly.activate();
}

function activateBoundary() {
  state.planningActive = false;
  state.drawActive = false;
  clearEvents();
}

function activatePath() {
  $('#snapshot_existing_step1').hide();
  $('#snapshot_draw_step1').hide();
  state.planningActive = false;
  setCursor({ type: 'crosshair' });
  state.drawActive = true;
  ol.controls.addPath.activate();
}

function activateFill() {
  $('#snapshot_existing_step1').hide();
  $('#snapshot_draw_step1').hide();
  state.fillFeatures = null;
  state.fillHistory = [];
  state.fillHistoryPointer = -1;
  state.fillOn = true;
  clearEvents();
  ol.controls.wfsInfo.activate();
}

function activatePan(highlight = false) {
  if (highlight) $('#pan-control').parent().addClass('active');
  $('#snapshot_existing_step1').hide();
  $('#snapshot_draw_step1').hide();
  $('#output').empty();
  ol.controls.doubleClickOverview.deactivate();
  setCursor({ type: 'default' });
  clearEvents();
  ol.layers.vector.events.un({
    featureclick: featClick,
  });
  ol.layers.vector.events.on({
    featureclick: featClick,
  });
  ol.layers.vector2.events.un({
    featureclick: polyClick,
  });
  state.planningActive = false;
  ol.layers.planningLayer.events.un({
    featureclick: planningclick,
  });
  ol.layers.lineSearchLayer.events.un({
    featureclick: lineSearchclick,
  });

  state.drawActive = false;
  if ($('#pan-control').parent().hasClass('active')) ol.controls.click.activate();
}
function cloneFeature(e) {
  state.selectTimer = setTimeout(() => {
    state.selectTimer = null;
  }, 500);
  state.modifyActive = true;
  setArea({ feat: e.feature, pa: state.planningActive });
  state.selectedFeature = e.feature;
  if (state.polysel) {
    setTimeout(function () {
      ol.controls.modifyLR.unselectFeature(e.feature);
      state.polysel = false;
    }, 100);
  } else {
    state.currentLR = e.feature.clone();
    const geom = e.feature.geometry.clone();
    state.latestFeature = [geom];
    state.modified = false;
  }
}
function registerModify(e) {
  state.modified = true;
  let newFeat;
  if (state.modified) {
    const newStyle = { ...styles.defaultStyle };
    newStyle.strokeColor = '#af00af';
    newStyle.strokeWidth = 2;
    newStyle.fillColor = '#e00000';
    newStyle.fillOpacity = 0.01;
    newFeat = new OpenLayers.Feature.Vector(e.feature.geometry.clone(), null, newStyle);
    newFeat.type = 'annotation';
    ol.layers.vector2.addFeatures(newFeat);
    ol.controls.modifyLR.unselectFeature(e.feature);
    ol.layers.vector.removeFeatures([e.feature]);
    ol.layers.vector.addFeatures([state.currentLR.clone()]);
  }
  state.modified = false;
  ol.controls.modifyFeature.selectFeature(newFeat);
}
function changeFeatureToAnnotation() {
  if (!state.selectTimer) {
    $('#output').empty();
    state.modifyActive = false;
  }
  state.modified = false;
}
function unselectFeature() {
  if (!state.selectTimer) {
    $('#output').empty();
    state.modifyActive = false;
  }
  ol.controls.doubleClick.deactivate();
}
function selectFeature(e) {
  $('#delete-tool').show();
  setArea({ feat: e.feature, pa: state.planningActive });
  state.modifyActive = true;
  state.selectTimer = setTimeout(() => {
    state.selectTimer = null;
  }, 500);
  state.selectedFeature = e.feature;
  if (e.feature.type === 'property') {
    ol.controls.doubleClick.activate();
  }
  state.polysel = true;
  setTimeout(function () {
    state.polysel = false;
  }, 500);
  if (state.lastEditMode !== 'Modifying') {
    state.lastEditMode = 'Selected';
    setTimeout(function () {
      state.lastEditMode = '';
    }, 200);
    const geom = e.feature.geometry.clone();
    if (state.latestFeature.length) {
      state.latestFeature.push(geom);
      state.latestFeaturePos = 1;
      $('#undo-redo-other').show();
    } else {
      state.latestFeature = [geom];
      state.latestFeaturePos = 0;
    }
    state.annotation = e.feature;
    state.polysearchSelected = state.annotation.polysearch;
  }
}
function activateIntersect() {
  ol.layers.vector2.features.forEach(function (feat) {
    if (feat.type === 'property') {
      state.clickedFeature = feat;
    }
  });
  if (state.clickedFeature) {
    state.snapsActive = true;
    if (!state.getting) {
      state.getting = true;
      getIntersects();
    } else {
      console.info('Notice: already retrieving titles');
    }
  }
}
function activateSelect(highlight = false) {
  if (highlight) $('#arrow-control').parent().addClass('active');
  clearEvents();
  state.selectActive = true;
  ol.controls.modifyLR.activate();
  ol.controls.modifyFeature.activate();
  setCursor({ type: 'default' });
  if (!state.selectTimer) $('#output').empty();
}
function activateDelete() {
  removeMatching();
  if (state.annotation) {
    if (state.annotation.subtype == 'property') {
      state.snapshotFeatures = [];
      $('#intersect-tool').hide();
      $('#snapshot-tool').hide();
      $('#snapshot_bar').hide();
      $('#snapshot_report_panel').hide();
      disableTools(false);
    }
    ol.layers.vector2.destroyFeatures([state.annotation]);
    ol.layers.error.destroyFeatures();
    ol.layers.vector2.redraw();
    state.annotation = null;
    event.stopPropagation();
    event.preventDefault();
    state.polysearchSelected = null;
  }
  activateSelect();
  $('.tool-butt').removeClass('active');
  $('.tool-butt').children().removeClass('active');
  $('#arrow-control').parent().addClass('active');
}
function activateDeleteAll() {
  $('#confirm-del').show();
  $('#confirm-del-ok')
    .off()
    .click(function () {
      state.savedFeatures.slice(0).forEach(feature => {
        removeSaved(feature.attributes.title_no);
      });
      ol.layers.vector2.destroyFeatures();
      ol.layers.vector.destroyFeatures();
      ol.layers.vector2.destroyFeatures();
      ol.layers.error.destroyFeatures();
      ol.layers.vectorOverview.destroyFeatures();
      ol.layers.vectorOverview.redraw();
      state.snapshotFeatures = [];
      $('#snapshot_report_panel').hide();
      disableTools(false);
      $('#snapshot-tool').hide();
      $('#snapshot_bar').hide();
      $('.tool-butt').removeClass('active');
      $('#boundary-control').parent().addClass('active');
      activateTool(null, 'pan');
      $('#confirm-del').hide();
    });
  $('#confirm-del-cancel')
    .off()
    .click(function () {
      $('.tool-butt').removeClass('active');
      $('#boundary-control').parent().addClass('active');
      activateTool(null, 'pan');
      $('#confirm-del').hide();
    });
}
function activateTool(e, tool) {
  if (tool !== 'snapshot' || (tool === 'snapshot' && state.lastMode !== 'snapshot')) {
    if (tool !== 'plan' && tool !== 'title') {
      state.lastMode = tool;
      state.lastEvent = e;
    }
    state.fillHistory = [];
    $('#undo-redo').hide();
    $('#undo-redo-flood').hide();
    $('#undo-redo-other').hide();
    if (state.fillFeatures) {
      if (
        state.fillFeatures.geometry.components &&
        state.fillFeatures.geometry.components.length > 1 &&
        state.fillFeatures.geometry.id.indexOf('MultiPolygon') > -1
      ) {
        ol.layers.vector2.removeFeatures([state.fillFeatures]);
        state.fillFeatures.geometry.components.forEach(function (poly) {
          const newPoly = poly.clone();
          const fillFeature = new OpenLayers.Feature.Vector(newPoly, null, {});
          fillFeature.style = styles.augment({}, colors.orange, 2, 0.25, colors.orange);
          fillFeature.type = 'annotation';
          ol.layers.vector2.addFeatures([fillFeature]);
        });
      }
    }
    state.fillFeatures = null;
    state.fillHistoryPointer = -1;
    state.fillOn = false;
    state.useExisting = false;
    $('#info-layer-switch').prop('checked', false);
    ol.controls.wfsInfo.deactivate();
    ol.controls.wmsInfo2.deactivate();
    ol.controls.wmsInfo3.deactivate();
    if (ol.controls.wfsInfo2) ol.controls.wfsInfo2.deactivate();

    $('.tool-butt').removeClass('active');
    $('.tool-butt').children().removeClass('active');
    if (tool !== 'snapshot') {
      $(`#${tool}-tool`).addClass('active');
      if (e) $(event.currentTarget).addClass('active');
    }
    setCursor({ type: 'default' });
    ol.controls.click.deactivate();
    ol.controls.addPath.deactivate();
    ol.controls.addPoly.deactivate();
    ol.controls.polyTitle.deactivate();
    $('#undo-redo').hide();
    $('#undo-redo-flood').hide();
    $('#undo-redo-other').hide();
    state.selectActive = false;
    state.drawActive = false;
    state.queryActive = false;
    if (state.annotation) {
      ol.controls.modifyFeature.unselectFeature(state.annotation);
      ol.layers.vector2.redraw();
    }
    ol.controls.modifyLR.deactivate();
    ol.controls.modifyFeature.deactivate();
    $('#color-box').hide();
    if (toolFunctions[tool]) toolFunctions[tool]();
    if (state.annotation) {
      ol.controls.modifyFeature.unselectFeature(state.annotation);
      state.annotation = null;
    }
  }
}

function showHideMarker() {
  ol.points.marker.style.display = ol.points.marker.style.display == 'none' ? 'block' : 'none';
  $('#pin-control').css('opacity', ol.points.marker.style.display == 'none' ? '0.9' : '0.5');
  ol.layers.vectorPin.redraw();
}
function moveMarker(xy2) {
  ol.points.markerSV.style.display = 'block';
  ol.points.markerSV.move(new OpenLayers.LonLat(xy2.eastings, xy2.northings));
  ol.layers.vectorPin.redraw();
}

function checkConnected(features, buffer) {
  if (buffer === null) buffer = false;
  let result;
  if (features.length == 0) result = null;
  else {
    const res = features.cascadeUnion(buffer);
    const union = res.poly ? res.poly : null;
    const holes = res.holes;
    const output_vector = new OpenLayers.Feature.Vector(
      union,
      null,
      styles.augment({ ...styles.defaultStyle }, colors.black, 1, 0, colors.black),
    );
    if (output_vector.geometry) {
      if (output_vector.geometry.components.length === 1) {
        result = output_vector;
      } else {
        if (holes) {
          result = 'MultiPolygon';
        } else {
          result = 'Polygons';
        }
      }
    } else {
      result = null;
    }
  }
  return result;
}

function joinPolygons() {
  var wkt = new OpenLayers.Format.WKT();
  var res = state.savedFeatures.cascadeUnion(false);
  var union = res.poly;
  var output_vector = new OpenLayers.Feature.Vector(
    union,
    null,
    styles.augment({ ...styles.defaultStyle }, colors.red, 2, 0.01, colors.red),
  );
  var output_wkt = wkt.write(output_vector);
  return { vector: output_vector, wkt: output_wkt };
}

function joinPolygons2() {
  const newStyle = { ...styles.defaultStyle };
  newStyle.strokeColor = '#e00000';
  newStyle.strokeWidth = 2;
  newStyle.fillColor = '#e00000';
  newStyle.fillOpacity = 0.01;
  const wkt = new OpenLayers.Format.WKT();
  const union = cascadeUnion(state.savedFeatures, false);
  if (!union.error) {
    const output_vector = new OpenLayers.Feature.Vector(union.poly, null, newStyle);
    return { vector: output_vector, wkt: wkt.write(output_vector) };
  } else {
    $('#blocker').hide();
    $('.sidebar').removeClass('disabled');
    $('#toolbar').show();
    $('#home').show();
    $('#pan-control').click();
    $('#confirm-button').show();
    return false;
  }
}

function geocode() {
  const centre = { lon: state.mousePos.lon, lat: state.mousePos.lat };
  if (state.currentFeature) {
    centre.lon = state.currentFeature.attributes.centre[0];
    centre.lat = state.currentFeature.attributes.centre[1];
  }
  const conv = new GT_OSGB();
  conv.setGridCoordinates(centre.lon, centre.lat);
  const wgs = conv.getWGS84();
  $.ajax({
    dataType: 'json',
    url: 'https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyDxPISSaq4_NIV8jOxBB9_6eIH-kYVN67A',
    data: {
      latlng: `${wgs.latitude},${wgs.longitude}`,
      sensor: false,
    },
    success: function (data) {
      if (data.results) {
        if (typeof data.results[0].formatted_address !== 'undefined') {
          $('#attr_address').text(data.results[0].formatted_address.toUpperCase());
          $('#attr_uprn').text('-');
          const address_components = data.results[0].address_components;
          const components = {};
          jQuery.each(address_components, function (k, v1) {
            jQuery.each(v1.types, function (k2, v2) {
              components[v2] = v1.long_name;
            });
          });
          if (components.street_number) {
            state.currentFeature.attributes.number = components.street_number.toUpperCase();
          }
          if (components.route) {
            state.currentFeature.attributes.street1 = components.route.toUpperCase();
          }
          if (components.postal_town) {
            state.currentFeature.attributes.town = components.postal_town.toUpperCase();
          }
          if (components.postal_code) {
            state.currentFeature.attributes.postcode = components.postal_code.toUpperCase();
          }
          state.currentFeature.attributes.address = data.results[0].formatted_address.toUpperCase();
          state.currentFeature.attributes.uprn = '-';
          state.currentFeature.attributes.add_source = 'Google Addresses';
          state.currentFeature.attributes.add_source_descr = 'Approximate address location';
        }
      } else {
        state.currentFeature.attributes.address = '-';
        state.currentFeature.attributes.uprn = '-';
        state.currentFeature.attributes.add_source = 'Google Addresses';
        state.currentFeature.attributes.add_source_descr = 'Approximate address location';
      }
      const mod = $('#snaps-button').is(':hidden') ? 205 : 170;
      $('#info-panel').height($('#info-panel .content').height() + mod);
    },
  });
}
function buildAddress(obj, $strip) {
  let addr = '';
  if ((typeof obj.name !== 'undefined' || typeof obj.number !== 'undefined') && typeof obj.street1 !== 'undefined') {
    if (!$strip || obj.unique) {
      if (obj.name) addr += obj.name + ', ';
      if (obj.number) addr += obj.number + ' ';
    }
    if (obj.street1) addr += obj.street1 + ', ';
    if (obj.street2) addr += obj.street2 + ', ';
    if (obj.locality1) addr += obj.locality1 + ', ';
    if (obj.locality2) addr += obj.locality2 + ', ';
    if (obj.town) addr += obj.town + ', ';
    if (obj.postcode) addr += obj.postcode + ', ';
    return addr.replace(/[, ]+$/, '');
  } else return '-';
}

function checkPolySearch(feature) {
  if (!state.selectTimer) {
    $('#output').empty();
    state.modifyActive = false;
  }
  ol.controls.doubleClick.deactivate();
  $('#delete-tool').hide();
  if (state.lastEditMode !== 'Modifying' && state.lastEditMode !== 'Selected') {
    if (feature.type === 'property') $('#undo-redo').hide();
    else $('#undo-redo-other').hide();
    state.latestFeature = [];
    state.latestFeaturePos = 0;
    setTimeout(function () {
      if (feature.feature.polysearch && state.polysearchSelected) {
        titleSearch(feature.feature, false);
      }
    }, 200);
  }
  storeSession();
}

function removeMatching() {
  const toremove = [];
  let i, f;
  for (i = 0; i < ol.layers.vector.features.length; i++) {
    f = ol.layers.vector.features[i];
    if (f.attributes.polysearch) {
      if (f.attributes.polysearch == state.polysearchSelected) toremove.push(f);
    }
  }
  if (toremove.length > 0) {
    ol.layers.vector.destroyFeatures(toremove);
    ol.layers.vector.redraw();
  }
}
function createguid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
function getDimensions(ap) {
  const tl = new OpenLayers.Layer.Vector('temp', {
    styleMap: new OpenLayers.StyleMap(styles.defaultStyle),
    renderers: ['Canvas', 'SVG', 'VML'],
  });
  tl.addFeatures(ap);
  const v1 = tl.getDataExtent();
  return v1.right - v1.left < 8000 && v1.top - v1.bottom < 8000;
}
async function confirmBoundary() {
  try {
    //    ol.functions.goHome({ state });
    storeSession();
    let error = false;
    state.boundaryActive = false;
    const allpolys = [];
    const allfeats = [];
    if (!state.usePlan) {
      for (const f of ol.layers.vectorSel.features) {
        const feat = f.geometry;
        if (feat.id.search('Polygon') !== -1 && f.style.fillColor == colors.faintred) {
          allpolys.push(new OpenLayers.Feature.Vector(feat.clone(), null, { ...styles.selStyle }));
          allfeats.push(f);
        }
      }
      state.separate = getAllFeaturesJSON(allfeats);
      //      state.combinedServer = await ServiceCalls.union(state.separate);
      allpolys.forEach(f => {
        const intersects = findSelfIntersects(f);
        if (intersects && intersects.length) throw { points: intersects };
      });
      if (!allpolys.length || getDimensions(allpolys)) {
        const connected = checkConnected(allpolys, true);
        if (!connected) {
          error = true;
          showError({
            state,
            title: 'Boundary Error',
            message: messages.boundaryError,
          });
        } else if (connected == 'MultiPolygon') {
          error = true;
          showError({ state, title: 'Boundary', message: messages.holes });
        }
      } else {
        state.downloadShapeActive = true;
        showError({
          state,
          title: 'Polygon Too Large',
          message: messages.orderTooLarge,
          callback: function () {
            state.downloadShapeActive = false;
            $('#blocker').hide();
            $('.sidebar').removeClass('disabled');
            $('#confirm-button').show();
          },
        });
        return;
      }
    }
    if (!error) {
      $('#address-panel').show();
      let centroid;
      if (!state.usePlan) {
        centroid = allpolys[0].geometry.getCentroid();
        let poly = allpolys[0].geometry.components[0].components;
        if (typeof poly[0].components !== 'undefined') {
          poly = poly[0].components;
        }
      } else {
        centroid = new OpenLayers.Geometry.Point(state.initx, state.inity);
      }
      $('#address-list').html(addressForm);
      const conv = new GT_OSGB();
      conv.setGridCoordinates(centroid.x, centroid.y);
      if (allpolys && allpolys[0] && allpolys[0].geometry && state.snapshotGeometry) {
        const wkt = new OpenLayers.Format.WKT();
        const ap = wkt.write(new OpenLayers.Feature.Vector(allpolys[0].geometry));
        const sg = wkt.write(new OpenLayers.Feature.Vector(state.snapshotGeometry));
        if (ap === sg) {
          $('#address-list .input-organisation').val($('#address-list2 .input-organisation').val());
          $('#address-list .input-premise').val($('#address-list2 .input-premise').val());
          $('#address-list .input-name-number').val($('#address-list2 .input-name-number').val());
          $('#address-list .input-street').val($('#address-list2 .input-street').val());
          $('#address-list .input-town').val($('#address-list2 .input-town').val());
          $('#address-list .input-postcode').val($('#address-list2 .input-postcode').val());
          $('#address-list .input-country').val($('#address-list2 .input-country').val());
          $('#address-list .input-county').val($('#address-list2 .input-county').val());
        } else {
          EventBroker.subscribe('getAddressFromPointResult', populateAddressFromPoint);
          state.addressCentroid = centroid;
          ServiceCalls.callService('getAddressFromPoint', {
            pointx: centroid.x,
            pointy: centroid.y,
            poly: '',
          });
        }
      } else {
        EventBroker.subscribe('getAddressFromPointResult', populateAddressFromPoint);
        state.addressCentroid = centroid;
        const wkt = new OpenLayers.Format.WKT();
        let ap;
        if (allpolys.length) {
          ap = wkt.write(new OpenLayers.Feature.Vector(allpolys[0].geometry));
          console.log(ap);
        }
        if (allpolys.length && allpolys.length === 1) {
          EventBroker.subscribe('getAddressFromPolyResult', populateAddressFromPoint);
          ServiceCalls.callService('getAddressFromPoly', {
            poly: ap,
          });
        } else {
          ServiceCalls.callService('getAddressFromPoint', {
            pointx: centroid.x,
            pointy: centroid.y,
            poly: '',
          });
        }
      }
    }
    $('#address-panel .continue-button')
      .off()
      .click(function () {
        state.confirmed_address = {
          organisation: $('#address-list .input-organisation').val(),
          premise: $('#address-list .input-premise').val(),
          'sub-premise': $('#address-list .input-subpremise').val(),
          numberOrName: $('#address-list .input-name-number').val(),
          street: $('#address-list .input-street').val(),
          town: $('#address-list .input-town').val(),
          postcode: $('#address-list .input-postcode').val(),
          country: $('#address-list .input-country').val(),
          county: $('#address-list .input-county').val(),
        };
        $('#address-panel').hide();
        const finalFeat = [];
        for (let i = 0; i < ol.layers.vectorSel.features.length; i++) {
          if (ol.layers.vectorSel.features[i].style.fillOpacity != 0.75) {
            finalFeat.push(ol.layers.vectorSel.features[i]);
          } else {
            ol.layers.vectorSel.features[i].style.fillOpacity = 0;
          }
        }
        ol.layers.vectorSel.destroyFeatures(finalFeat);
        ol.layers.vectorSel.redraw();
        createFinalCall();
      });
  } catch (e) {
    if (e.points) {
      ol.layers.error.removeFeatures([ol.points.error]);
      if (ol.popup) {
        ol.map.removePopup(ol.map.popups[0]);
        ol.popup = null;
      }
      showGeometryError(e.points);
      showError({
        state,
        title: 'Progress Error',
        message: messages.crossoverError2,
        callback: function () {
          $('#blocker').hide();
          $('.sidebar').removeClass('disabled');
          $('#confirm-button').show();
          cancelBoundary();
          activateTool(null, 'select');
        },
      });
    } else {
      showError({
        state,
        title: 'Progress Error',
        message: messages.polygonError,
        callback: function () {
          $('#blocker').hide();
          $('.sidebar').removeClass('disabled');
          $('#confirm-button').show();
          cancelBoundary();
          activateTool(null, 'select');
        },
      });
    }
  }
}
function populateAddressFromPoint(evt) {
  if (evt.response) {
    populatePrimary(typeof evt.response === 'string' ? JSON.parse(evt.response) : evt.response);
  } else {
    const conv = new GT_OSGB();
    conv.setGridCoordinates(state.addressCentroid.x, state.addressCentroid.y);
    const wgs = conv.getWGS84();
    $.ajax({
      dataType: 'json',
      url: 'https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyDxPISSaq4_NIV8jOxBB9_6eIH-kYVN67A',
      data: {
        latlng: `${wgs.latitude},${wgs.longitude}`,
        sensor: false,
      },
      success: function (data) {
        const address_components = data.results[0].address_components;
        const components = {};
        jQuery.each(address_components, function (k, v1) {
          jQuery.each(v1.types, function (k2, v2) {
            components[v2] = v1.long_name;
          });
        });
        const prop = {};
        if (components.street_number) prop.number = components.street_number;
        else if (components.premise) prop.number = components.premise;
        prop.street1 = components.route;
        prop.town = components.postal_town;
        prop.county = components.administrative_area_level_2;
        prop.country = components.country;
        prop.postcode = components.postal_code;
        populatePrimary(prop);
      },
    });
  }
}
function usePlan() {
  if (!getCookie('usePlanSeen') && !state.usePlanSeen) {
    $('#blocker').show();
    $('#usePlanPrompt').show();
    state.usePlanSeen = true;
  }
  ol.controls.dragmarker.activate();
  ol.layers.vector.setVisibility(false);
  activateTool(null, 'plan');
  state.usePlan = true;
  $('#useplan-confirm').show();
  $('#confirm-button').hide();
}
function getAllPolygons() {
  state.usePlan = false;
  let feat, comp;
  if (state.currentBM == 'aerialLayer') {
    $('.base-layer').css('background-color', '#ffffff');
    state.currentBM = 'mmLayer';
    $(`#${state.currentBM}-toggle`).css('background-color', '#ff844e');
    $(`#cb-${state.currentBM}`).click();
    $('#cb-aerialLayer').prop('checked', false);
    $('#cb-bwLayer').prop('checked', false);
  }
  if (state.savedFeatures.length > -1) {
    $('#search-confirm').show();
    $('#confirm-button').hide();
    $('#toolbar').hide();
    $('#home').hide();
    const allpolys = [];
    let i, j;
    for (i = 0; i < ol.layers.vector.features.length; i++) {
      feat = ol.layers.vector.features[i].geometry;
      if (feat.id.search('Multi') !== -1) {
        for (j = 0; j < feat.components.length; j++) {
          comp = feat.components[j];
          allpolys.push(new OpenLayers.Feature.Vector(comp.clone(), null, { ...styles.selStyle }));
        }
      } else if (feat.id.search('Polygon') !== -1) {
        allpolys.push(new OpenLayers.Feature.Vector(feat.clone(), null, { ...styles.selStyle }));
      }
    }
    for (i = 0; i < ol.layers.vector2.features.length; i++) {
      feat = ol.layers.vector2.features[i].geometry;
      if (feat.id.search('Multi') !== -1) {
        for (j = 0; j < feat.components.length; j++) {
          comp = feat.components[j];
          allpolys.push(new OpenLayers.Feature.Vector(comp.clone(), null, { ...styles.selStyle }));
        }
      } else if (feat.id.search('Polygon') !== -1) {
        allpolys.push(new OpenLayers.Feature.Vector(feat.clone(), null, { ...styles.selStyle }));
      }
    }
    let connected = null;
    ol.layers.vectorSel.destroyFeatures();
    ol.layers.vectorSel.addFeatures(allpolys);
    ol.layers.vectorSel.setVisibility(true);
    showExtraLayers(false);
    ol.layers.vectorSel.redraw();
    ol.controls.click.deactivate();
    state.boundaryActive = true;
    clearEvents();
    activateTool(null, 'boundary');
    $('.sidebar').addClass('disabled');
    return { allpolys: allpolys, connected: connected };
  } else {
    showError({ state, title: 'Titles', message: 'No saved titles' });
  }
}

function showExtraLayers(vis) {
  ol.layers.vectorPin.setVisibility(vis);
  if (vis) {
    $('#layerSwitch').show();
    $('.arrow').hide();
  } else {
    $('#layerSwitch').hide();
    $('.arrow').show();
  }
  if (ol.arrays.addedOlLayers.length > 0) {
    for (let i = 0; i < ol.arrays.addedOlLayers.length; i++) {
      ol.arrays.addedOlLayers[i].setVisibility(vis);
    }
  }
  if (ol.arrays.addedWFSOlLayers.length > 0) {
    for (let n = 0; n < ol.arrays.addedWFSOlLayers.length; n++) {
      ol.arrays.addedWFSOlLayers[n].setVisibility(vis);
    }
  }
  ol.layers.planningLayer.setVisibility(vis);
  ol.layers.lineSearchLayer.setVisibility(vis);
}

function hideShowLayer(layer, hide) {
  layer.setVisibility(!hide);
  layer.redraw();
}
function planCancel() {
  ol.controls.dragmarker.deactivate();
  ol.layers.vector.setVisibility(true);

  if (state.lastMode) activateTool(true, state.lastMode);
  $('#useplan-confirm').hide();
  $('#confirm-button').show();
  $('#toolbar').show();
  $('#home').show();
}
function cancelBoundary() {
  ol.layers.vectorSel.destroyFeatures();
  ol.layers.vectorSel.setVisibility(false);
  state.boundaryActive = false;
  hideShowLayer(ol.layers.vector, false);
  hideShowLayer(ol.layers.vector2, false);
  $('.sidebar').removeClass('disabled');
  activateTool(null, 'pan');
  $('#search-confirm').hide();
  $('#confirm-button').show();
  $('#toolbar').show();
  $('#home').show();
  showExtraLayers(true);
}
async function createFinalCall() {
  let finalJSONString;
  if (!state.frozen) {
    $('#search-confirm').hide();
    $('#confirm-button').hide();
    $('#blocker').show();
    if (!state.usePlan) {
      state.savedFeatures = ol.layers.vectorSel.features;
      const writer = new OpenLayers.Format.GeoJSON();
      const geoJSON = writer.write(ol.layers.vectorSel.features, true);
      let combined = joinPolygons();
      const combinedimg = joinPolygons2();
      if (combinedimg) {
        ol.layers.vectorSel.destroyFeatures();
        ol.layers.vectorSelCombined.destroyFeatures();
        ol.layers.vectorSel.addFeatures([combinedimg.vector]);
        ol.layers.vectorSelCombined.addFeatures([combined.vector]);
        checkLineWidth();
        ol.layers.vectorSel.redraw();
        state.finalWKT = combined.wkt;
        combined = combined.vector;
        if ($.isArray(combined)) combined = combined[0];
        ol.layers.vector.destroyFeatures();
        ol.layers.vector2.destroyFeatures();
        ol.layers.vector.addFeatures([combined]);
        ol.layers.vector.setVisibility(false);
        ol.layers.planningLayer.setVisibility(false);
        ol.layers.lineSearchLayer.setVisibility(false);
        state.finalCentroid = combined.geometry.getCentroid();
        state.finalArea = combined.geometry.getArea();
        if ($('#downloadShape')[0].checked) {
          const geoJSON2 = writer.write(ol.layers.vectorSelCombined.features, true);
          const response = await $.ajax({
            url: '/nodeservice/convert/shapefile',
            type: 'POST',
            data: {
              json: geoJSON,
              type: 'base64',
              folder: 'separate',
            },
          });
          const response2 = await $.ajax({
            url: '/nodeservice/convert/shapefile',
            type: 'POST',
            data: {
              json: geoJSON2,
              type: 'base64',
              folder: 'combined',
            },
          });
          saveB64(response, `separate_${guid}_shapefile.zip`);
          saveB64(response2, `combined_${guid}_shapefile.zip`);
        }
        const json = getFeaturesGeomJSON(ol.layers.vectorSelCombined, true);
        const json2 = getFeaturesGeomJSON(ol.layers.vectorSelCombined, true, true);
        const imagejson = getFeaturesGeomJSON(ol.layers.vectorSel, true, true);
        state.uncleanJSONString = [imagejson]; //.processGeomArray2(); //finalJSONString;
        state.combinedJSONString = [json2];

        if (json.length > 1) {
          if (typeof json[0][0][0] == 'number') {
            finalJSONString = [json[0]].processGeomArray();
          } else {
            finalJSONString = '[';
            for (let j = 0; j < json.length; j++) {
              let arr = [];
              arr.push(json[j]);
              if (arr[0].length > 1 || typeof arr[0][0][0][0] == 'number') {
                arr = [arr[0][0]];
              }
              finalJSONString += `${arr.processGeomArray(arr)},`;
            }
            finalJSONString = `${finalJSONString.substring(0, finalJSONString.length - 1)}]`;
          }
          /*multipolygon*/
        } else {
          finalJSONString = json.processGeomArray();
        }
      } else {
        return false;
      }
    } else {
      state.finalCentroid = new OpenLayers.Geometry.Point(state.initx, state.inity);
    }
    const extent = ol.layers.vector.getDataExtent();
    if (finalJSONString) finalJSONString = removeDuplicates(finalJSONString).json;
    ol.map.zoomToExtent(extent);
    if (state.usePlan) {
      ol.functions.goHome({ state });
    }
    state.finalJSONString = finalJSONString;
    sendImage();
  } else if (state.savedFeatures.length === 0) {
    state.client.publish('/gettitles-' + guid, '{"error":"no saved titles"}');
  } else {
    state.client.publish('/gettitles-' + guid, '{"error":"session frozen"}');
  }
}

function checkBoundaryMove(e) {
  if (e.feature.type == 'property') {
    $('#editToolbar').show();
    $('#undo-redo').show();
  } else $('#undo-redo-other').show();
  setTimeout(function () {
    storeSession();
  }, 500);
  if (e.feature.geometry.components[0].components.length == 3) {
    ol.controls.modifyFeature.unselectFeature(e.feature);
    ol.layers.vector2.destroyFeatures([e.feature]);
  } else {
    state.latestFeaturePos++;
    state.latestFeature = state.latestFeature.slice(0, state.latestFeaturePos);
    const geom = e.feature.geometry.clone();
    state.latestFeature.push(geom);
  }
  const crossover = findSelfIntersects(e.feature);
  ol.layers.error.removeFeatures([ol.points.error]);
  if (ol.popup) {
    ol.map.removePopup(ol.map.popups[0]);
    ol.popup = null;
  }

  if (crossover && crossover.length) {
    showGeometryError(crossover, false);
    showError({
      state,
      title: 'Progress Error',
      message: messages.crossoverError,
    });
  }
  setArea({ feat: e.feature, pa: false });
}
function showDiagnostics() {
  const ok = "<span style='color:#90ff90'>OK</span><br />";
  const fail = "<span style='color:#ff9090'>Fail</span><br />";
  const diag = $('#diagnostics .message');
  const client2 = new Faye.Client(settings.fayeServer);
  client2.disable('websocket');
  diag.empty();
  $('#diagnostics').show();
  $('#diagnostics .ok')
    .off()
    .click(function () {
      if (state.currentCursor) setCursor({ type: state.currentCursor });
      $('#diagnostics').hide();
      $('#blocker').hide();
    });
  $('#blocker').show();
  const ms = ol.map ? ok : fail;
  diag.append('Mapping Subsystem: ' + ms);
  diag.append('Mapping: ');
  const ajaxObj = {
    url:
      'https://mapgateway-aws.findmaps.co.uk/wms/searchacumen/jxq6fI4tR0g9eTu4?tiled=true&trk=-6&clientid=-6&LAYERS=OS%3AOS%20Mastermap%20(Live)%20FG&TRANSPARENT=FALSE&CLEANUP=1&SERVICE=WMS&VERSION=1.1.1&REQUEST=GetMap&STYLES=&FORMAT=image%2Fjpeg&SRS=EPSG%3A27700&BBOX=532392,179424,532448,179480&WIDTH=256&HEIGHT=256',
    type: 'GET',
  };
  $.ajax(ajaxObj)
    .done(function () {
      diag.append(ok);
      diag.append('Session: ' + localStorage ? ok : fail);
      const ajaxObj = {
        url: 'service/service.php',
        type: 'POST',
        data: { request: 'check' },
      };
      diag.append('Service calls: ');
      $.ajax(ajaxObj)
        .done(function (response) {
          if (response === 'success') {
            diag.append(ok);
            diag.append('Pub/Sub Service: ');
            try {
              const sub2 = client2.subscribe(`/${guid}_test`, function () {
                diag.append(ok);
                sub2.cancel();
              });
              const ajaxObj = {
                url: 'service/service.php',
                type: 'POST',
                data: { request: 'checkfaye', sessionid: guid },
              };
              setTimeout(function () {
                $.ajax(ajaxObj).fail(function () {
                  diag.append(fail);
                });
              }, 500);
            } catch (err) {
              diag.append(fail);
              diag.append(err);
            }
          } else {
            diag.append(fail);
          }
        })
        .fail(function (error) {
          diag.append(fail);
          diag.append(error);
        });
    })
    .fail(function (error) {
      diag.append(fail);
      diag.append(error);
    });
}

function showDialog(e) {
  new Clipboard('.copy-btn');
  const lonlat = ol.map.getLonLatFromPixel(e.xy);
  $('#dialog-coords').text(`${Math.round(lonlat.lon)},${Math.round(lonlat.lat)}`);
  $('#close-dialog')
    .off()
    .on('click', function () {
      $('#dialog-coords').text('');
      $('#dialog').hide();
    });
  $('#dialog').show();
}
const checkUPRNS = key => {
  if (key == 'ArrowLeft') {
    state.currentUPRNPoint =
      state.currentUPRNPoint < ol.layers.tempMarkup.features.length - 1 ? state.currentUPRNPoint.length + 1 : 0;
  }
  if (key == 'ArrowRight') {
    state.currentUPRNPoint =
      state.currentUPRNPoint > 0 ? state.currentUPRNPoint - 1 : ol.layers.tempMarkup.features.length - 1;
  }
  setRestricted(null);
  const pt = ol.layers.tempMarkup.features[state.currentUPRNPoint].geometry;
  const c = new OpenLayers.LonLat(pt.x, pt.y);
  ol.map.setCenter(c);
  setRestricted(new OpenLayers.Bounds(c.lon - 5162, c.lat - 5162, c.lon + 5162, c.lat + 5162));
};
const showShapeUpload = () => {
  $('#close-shp')
    .off()
    .on('click', () => $('#shpUpload').hide());
  $('#shpUpload').show();
  $('#shpFile')
    .off()
    .on('change', function () {
      const processJSON = json => {
        const GeoReader = new OpenLayers.Format.GeoJSON();
        const feats = GeoReader.read(json).filter(o => o.geometry);
        if (feats.length) {
          const newStyle = { ...styles.defaultStyle };
          feats.forEach(feat => {
            feat.type = 'annotation';
            feat.style = styles.augment(newStyle, state.currentColor, 2, 0);
            ol.layers.vector2.addFeatures(feat);
          });
          setRestricted(null);
          const newExtent = feats[0].geometry.getBounds();
          const newZoom = ol.map.getZoomForExtent(newExtent);
          const newCenter = [
            newExtent.left + (newExtent.right - newExtent.left) / 2,
            newExtent.bottom + (newExtent.top - newExtent.bottom) / 2,
          ];
          const c = new OpenLayers.LonLat(newCenter[0], newCenter[1]);
          ol.map.setCenter(c);
          if (newZoom < 10)
            setRestricted(new OpenLayers.Bounds(c.lon - 5162, c.lat - 5162, c.lon + 5162, c.lat + 5162));
          else setRestricted(null);
          if (newZoom !== ol.map.getZoom()) ol.map.zoomTo(newZoom > 12 ? 12 : newZoom);
        } else {
          showError({
            title: 'Shapefile upload error',
            message: 'Please ensure shapefile is valid and in a zipped container',
          });
        }
        $('#shpFile').val('');
      };
      if ($('#shpFile').val !== '') {
        const reader = new FileReader();
        reader.onload = () => {
          if (typeof reader.result == 'string') {
            processJSON(reader.result);
          } else {
            shp(reader.result)
              .then(async geojson => {
                const json = await reproject(geojson, 'EPSG:4326', Proj4js.defs['EPSG:27700']);
                processJSON(json);
              })
              .catch(e => {
                showError({
                  title: 'Shapefile upload error',
                  message: e.message,
                });
                $('#shpFile').val('');
              });
          }
        };
        if (this.files[0].name.endsWith('.json')) {
          reader.readAsText(this.files[0]);
        } else {
          reader.readAsArrayBuffer(this.files[0]);
        }
        $('#shpUpload').hide();
      }
    });
};
const showWKT = () => {
  new Clipboard('.copy-btn');
  const wktWriter = new OpenLayers.Format.WKT();
  const wkt = wktWriter.write(state.selectedFeature);
  $('#dialog-coords').text(wkt);
  $('#close-dialog')
    .off()
    .on('click', function () {
      $('#dialog-coords').text('');
      $('#dialog').hide();
    });
  $('#dialog').show();
};
async function keyboardHandler(e) {
  const key = e.key;
  state.shiftDown = e.shiftKey;
  console.log(key, e.ctrlKey, e.altKey);
  if (key == 'ArrowLeft' || (key == 'ArrowRight' && ol.layers.tempMarkup.features.length)) checkUPRNS(key);
  if (key == 'z') {
    const controls = ol.map.getControlsByClass('OpenLayers.Control.Navigation');
    for (let i = 0; i < controls.length; ++i) controls[i].enableZoomWheel();
  }
  if (e.ctrlKey && e.altKey && key == 'w' && state.selectedFeature) {
    showWKT();
  }
  if (e.ctrlKey && e.altKey && key == 'g') {
    showShapeUpload();
  }
  if (e.ctrlKey && e.altKey && key == 'd') {
    showDiagnostics();
  }
  if (e.ctrlKey && e.altKey && key == 'p') {
    $('#planningSearch').show();
    $('#btnPlanningSearch')
      .off()
      .on('click', () => {
        getPlanningApplications({ state, ol });
        $('#planningSearch').hide();
      });
  }
  if (e.ctrlKey && e.altKey && key == 'u') {
    $('#uprns').show();
    $('#clear-uprns')
      .off()
      .on('click', () => clearTempMarkup(ol.layers.tempMarkup));
    $('#close-uprns')
      .off()
      .on('click', () => {
        $('#uprns').hide();
      });
    $('#send-uprns')
      .off()
      .on('click', () => {
        getCoordsFromUPRNs($('#uprn-list').val());
      });
  }
  if (e.ctrlKey && e.altKey && key == 'j') {
    downloadJSON(ol.layers.vector, ol.layers.vector2);
  }
  if (e.ctrlKey && e.altKey && key == 's') {
    if (state.downloadShapeActive) {
      const writer = new OpenLayers.Format.GeoJSON();
      state.savedFeatures = ol.layers.vectorSel.features;
      let poly = joinPolygons();
      const combined = joinPolygons2();
      let geoJSON = writer.write(poly.vector, true);
      let geoJSON2 = writer.write(combined.vector, true);
      geoJSON = JSON.stringify({ type: 'FeatureCollection', features: [JSON.parse(geoJSON)] });
      geoJSON2 = JSON.stringify({ type: 'FeatureCollection', features: [JSON.parse(geoJSON2)] });
      const response = await $.ajax({
        url: '/nodeservice/convert/shapefile',
        type: 'POST',
        data: {
          json: geoJSON,
          type: 'base64',
          folder: 'separate',
        },
      });
      const response2 = await $.ajax({
        url: '/nodeservice/convert/shapefile',
        type: 'POST',
        data: {
          json: geoJSON2,
          type: 'base64',
          folder: 'combined',
        },
      });
      saveB64(response, `separate_${guid}_shapefile.zip`);
      saveB64(response2, `combined_${guid}_shapefile.zip`);
    }
    $('.shp').toggle('fast', () => {
      if (!$('.shp').is(':visible')) {
        $('#downloadShape').prop('checked', false);
      }
    });
  }
  if (e.ctrlKey && e.altKey && key == 'k') {
    downloadJSON(ol.layers.vector2);
  }
  if (key == 'Delete') {
    activateTool(null, 'delete');
  }
  if (key == 'Control') {
    ol.controls.snap.deactivate();
  }
  if (key == 'v' && state.lastMode == 'Complete') {
    ol.layers.vectorSel.setVisibility(!ol.layers.vectorSel.getVisibility());
    ol.layers.vectorSelCombined.setVisibility(!ol.layers.vectorSelCombined.getVisibility());
  }
}

function keyboardUpHandler(e) {
  state.shiftDown = false;
  const key = e.key;
  if (key == 'Control') {
    ol.controls.snap.activate();
  }
  if (key == 'z') {
    const controls = ol.map.getControlsByClass('OpenLayers.Control.Navigation');
    for (let i = 0; i < controls.length; ++i) controls[i].disableZoomWheel();
  }
}

// Add to patch
function checkLineWidth() {
  if (ol.layers.vectorSel.features.length > 0) {
    const item = ol.layers.vectorSel.features[0];
    item.style.strokeWidth = ol.map.getZoom() > 6 ? ol.map.getZoom() - 6 : 1;
    ol.layers.vectorSel.redraw();
  }
}
const cleanPoly = f => {
  const crossovers = findSelfIntersects(f);
  if (crossovers && crossovers.length) {
    const parser = new jsts.io.OpenLayersParser();
    try {
      const jstsPolygon = parser.read(f.geometry); //.buffer(0);
      const cleaned = jsts_validate(jstsPolygon);
      const cleanedGeom = parser.write(cleaned);
      f.geometry = cleanedGeom;
      return f;
    } catch (e) {
      const jstsPolygon2 = parser.read(f.geometry).buffer(0);
      const cleanedGeom2 = parser.write(jstsPolygon2);
      f.geometry = cleanedGeom2;
      return f;
    }
  } else return f;
};
const findSelfIntersects = feature => {
  const parser = new jsts.io.OpenLayersParser();
  const jstsPolygon = parser.read(feature.geometry);
  const validator = new jsts.operation.IsSimpleOp(jstsPolygon);
  if (validator.isSimpleLinearGeometry(jstsPolygon)) {
    return;
  }
  const res = [];
  const graph = new jsts.geomgraph.GeometryGraph(0, jstsPolygon);
  const cat = new jsts.operation.valid.ConsistentAreaTester(graph);
  const r = cat.isNodeConsistentArea();
  if (!r) {
    const pt = cat.getInvalidPoint();
    res.push([pt.x, pt.y]);
  }
  return res;
};

function cascadeUnion(features, buffer) {
  let holes = false;
  const parser = new jsts.io.OpenLayersParser();
  const jstsPolygons = [];
  for (let i = 0; i < features.length; i++) {
    const poly = parser.read(features[i].geometry);
    if (buffer) jstsPolygons.push(poly.buffer(0.2));
    else jstsPolygons.push(poly);
  }
  window.jstsPolygons = jstsPolygons;
  try {
    let mergedPolygon;
    try {
      mergedPolygon = jsts.operation.union.CascadedPolygonUnion.union(jstsPolygons);
    } catch (e) {
      jstsPolygons[1] = jstsPolygons[1].buffer(0);
      jstsPolygons[0] = jstsPolygons[0].buffer(0);
      mergedPolygon = jsts.operation.union.CascadedPolygonUnion.union(jstsPolygons);
    }
    if (buffer) mergedPolygon = mergedPolygon.buffer(-0.2);
    if (typeof mergedPolygon.holes !== 'undefined') {
      holes = true;
    }
    return { poly: parser.write(mergedPolygon), holes: holes };
  } catch (e) {
    showError({
      state,
      title: 'Progress Error',
      message: messages.hmlrError,
    });
    return { poly: [], holes: [], error: 'failed to union' };
  }
}

function storeSession() {
  if (state.storeSessionTimer) clearTimeout(state.storeSessionTimer);
  state.storeSessionTimer = setTimeout(function () {
    let uiState = {};
    uiState.center = ol.map.getCenter();
    uiState.zoom = ol.map.getZoom();
    uiState.vector = ol.functions.getFeaturesJSON(false);
    uiState.overlays = JSON.stringify(ol.arrays.addedLayers.concat(ol.arrays.addedWFSLayers).join('|'));
    uiState.guid = guid;
    uiState.lastMode = state.lastMode;
    sessionStorage.setItem('session-' + guid, JSON.stringify(uiState));
    const json = ol.functions.getFeaturesJSON(false);
    const anno = ol.functions.getFeaturesJSON(false, ol.layers.vector2);
    ServiceCalls.callService('updateStatus', {
      json: json,
      anno: anno,
      guid: guid,
      projectid: project.project_id,
    });
  }, 1000);
}
const getRestrictions = () => {
  return JSON.stringify({ prow, county, origcountry, auth });
};
const getLayerCheck = () => {
  return JSON.stringify({ raillayers, wmslayercheck });
};
function createSnapshotReport() {
  state.snapshotProgress = 0;
  state.snapshotLayerCount = 0;
  $('#snapshot_progress_icon').hide();
  const extent = ol.layers.vector2.getDataExtent();
  extent.top += (extent.top - extent.bottom) / 50;
  extent.bottom -= (extent.top - extent.bottom) / 50;
  extent.right += (extent.right - extent.left) / 50;
  extent.left -= (extent.right - extent.left) / 50;
  const extentObj = ol.functions.getVectorExtent(extent);
  let snapsAddressString = '';
  snapsAddressString +=
    $('#address-list2 .input-organisation').val() && $('#address-list2 .input-organisation').val() + ', ';
  snapsAddressString += $('#address-list2 .input-premise').val() && $('#address-list2 .input-premise').val() + ', ';
  snapsAddressString +=
    $('#address-list2 .input-subpremise').val() && $('#address-list2 .input-subpremise').val() + ', ';
  snapsAddressString +=
    $('#address-list2 .input-name-number').val() && $('#address-list2 .input-name-number').val() + ', ';
  snapsAddressString += $('#address-list2 .input-street').val() && $('#address-list2 .input-street').val() + ', ';
  snapsAddressString += $('#address-list2 .input-town').val() && $('#address-list2 .input-town').val() + ', ';
  snapsAddressString += $('#address-list2 .input-county').val() && $('#address-list2 .input-county').val() + ', ';
  snapsAddressString += $('#address-list2 .input-postcode').val() && $('#address-list2 .input-postcode').val() + ', ';
  snapsAddressString +=
    $('#address-list2 .input-country').val() &&
    $('#address-list2 .input-country').val().replace('United Kingdom', 'UK');
  snapsAddressString = snapsAddressString.replace(/,\s*$/, '').replace(/undefined/g, '');
  state.snapsAddressString = snapsAddressString;
  const snapshotJSON = getSnapshotJSON();
  state.snapshotGeometry = state.snapshotFeatures[0].geometry;
  ServiceCalls.callService('createSnapshotReport', {
    search: snapshotJSON,
    area: state.snapshotFeatures[0].geometry.getArea(),
    groups: state.snapshotGroups.toString(),
    layers: state.snapshotLayers.toString(),
    address: state.snapsAddressString,
    restrict: getRestrictions(),
    layercheck: getLayerCheck(),
    extentString: extentObj.extentString,
    casefile: $('.input-casefile').val(),
    extent: extentObj.extent,
    sessionId: guid,
    searchID: searchID || '',
    endpoint: endpoint,
    log: !settings.skipPlanningLog,
    projectId: project.project_id,
  });
}

function snapsAddress() {
  const { price } = calculatePrice({
    groups: state.snapshotGroups,
    layers: state.snapshotLayers,
    area: state.snapshotFeatures[0].geometry.getArea(),
    parcels: state.parcelCount,
  });
  $('#price2').text(price.toString());
  closeInfo({ state, ol, featClick, setCursor, activateSelect });
  $('#address-panel2').show();
  $('.input-casefile').val(project.casefile_ref);
  const centroid = ol.layers.vector2.features[0].geometry.getCentroid();
  $('#address-list2').html(addressForm);
  const conv = new GT_OSGB();
  conv.setGridCoordinates(centroid.x, centroid.y);
  EventBroker.subscribe('getAddressFromPointResult', populateAddressFromPoint);
  ServiceCalls.callService('getAddressFromPoint', {
    pointx: centroid.x,
    pointy: centroid.y,
    poly: '',
  });
  $('#address-panel2 .snaps-close-button')
    .off()
    .click(function () {
      $('#address-panel2').hide();
      disableTools(false);
      cleanupSnapshot();
    });
  $('#address-panel2 .snaps-confirm-button')
    .off()
    .click(function () {
      disableTools(false);
      createSnapshotReport();
      $('#address-panel2').hide();
      $('#snapshot_progress').removeClass('ready');
      $('#snapshot_progress').show();
      $('#snapshot_progress_close').hide();
      $('#snapshot_progress_shrink').show();
      $('#snap_prog').html('Progress: Starting report...');
      cleanupSnapshot();
    });
}
function openhelp(val) {
  $('.helpSub').hide();
  $('#helpPanel' + val).show();
}
function subtractFromFeature(positiveFeature, negativeFeature) {
  const parser = new jsts.io.OpenLayersParser();
  return new OpenLayers.Feature.Vector(
    parser.write(parser.read(positiveFeature.geometry).difference(parser.read(negativeFeature.geometry))),
  );
}
function drawWFS(e) {
  if (state.fillHistoryPointer !== state.fillHistory.length - 1) {
    state.fillHistory.splice(state.fillHistoryPointer + 1, state.fillHistory.length - (state.fillHistoryPointer + 1));
  }
  if (state.fillFeatures) ol.layers.vector2.removeFeatures([state.fillFeatures]);
  const feat = e.feature;
  const newStyle = {};
  jQuery.extend(newStyle, styles.defaultStyle);
  if (!state.shiftDown) {
    if (state.fillFeatures) {
      const union = cascadeUnion([feat, state.fillFeatures], false);
      state.fillFeatures = new OpenLayers.Feature.Vector(union.poly, null, newStyle);
    } else {
      state.fillFeatures = feat;
    }
  } else {
    if (state.fillFeatures) state.fillFeatures = subtractFromFeature(state.fillFeatures, feat);
  }
  if (state.fillFeatures) {
    state.fillFeatures.style = styles.augment(newStyle, colors.orange, 2, 0.25, colors.orange);
    state.fillFeatures.type = 'annotation';
    ol.layers.vector2.addFeatures([state.fillFeatures]);
    state.fillHistory.push(state.fillFeatures.clone());
    state.fillHistoryPointer = state.fillHistory.length - 1;
    $('#undo-redo-flood').show();
    showArea(state.fillFeatures);
  }
}
function featuresAdded() {
  $('#delete-all-tool').show();
  $('#select-tool').show();
  $('#editToolbar').show();
  ol.functions.setUpOverview(ol.layers.vector.features);
}
function featuresRemoved() {
  if (ol.layers.vector2.features.length == 0 && ol.layers.vector.features.length == 0) {
    $('#delete-all-tool').hide();
    $('#select-tool').hide();
    $('#editToolbar').hide();
    ol.functions.setUpOverview(ol.layers.vector.features);
  }
}
const UISetup = async callback => {
  $('#fullScreen').on('click', () => {
    if (!state.isFullScreen) $('#body')[0].requestFullscreen();
    else document.exitFullscreen();
  });
  document.addEventListener(
    'fullscreenchange',
    () => {
      state.isFullScreen = !!document.fullscreenElement;
      const c = state.isFullScreen ? { b: 'expand', a: 'compress' } : { b: 'compress', a: 'expand' };
      $('#fullScreenIcon').switchClass(`fa-${c.b}`, `fa-${c.a}`);
      setTimeout(() => {
        for (const l in ol.layers) ol.layers[l] && ol.layers[l].visibility && ol.layers[l].redraw();
      }, 200);
    },
    false,
  );
  if (getCookie('cheaperSeen')) deleteCookie('cheaperSeen');
  const layerFetch = await window.fetch(`/nodeservice/getLayers?rand=${Math.random()}`);
  $('[contenteditable]')
    .focusout(function () {
      const element = $(this);
      if (!element.text().trim().length) {
        element.empty();
      }
    })
    .keydown(e => {
      if (e.key === 'Enter') {
        $('#search').click();
        e.preventDefault();
      }
    });
  state.layers = await layerFetch.json();
  buildLayerList(state.layers, layerProps => {
    state.layerProps = layerProps;
    $('#search')
      .off()
      .on('click', () => {
        const obj = {};
        let searchVal = $('#site_search').text();
        searchVal = searchVal.replace(/\n/g, ',');
        if (searchVal) {
          const searchArray = searchVal.split(',').map(s => s.trim());
          if (searchArray.length === 2 && searchArray[0].match(/^\d+$/) && searchArray[0].match(/^\d+$/)) {
            setRestricted(null);
            const coord = { x: parseFloat(searchArray[0]), y: parseFloat(searchArray[1]) };
            ol.map.setCenter(new OpenLayers.LonLat(coord.x, coord.y));
            setRestricted(new OpenLayers.Bounds(coord.x - 5162, coord.y - 5162, coord.x + 5162, coord.y + 5162));
            if (ol.points.marker2) ol.layers.vectorPin.removeFeatures([ol.points.marker2]);
            ol.layers.vectorPin.addFeatures([ol.points.marker2]);
            ol.points.marker2.move(new OpenLayers.LonLat(coord.x, coord.y));
          } else {
            obj.title = searchVal.toUpperCase();
            $('#site_search').text(obj.title);
            ServiceCalls.callService('search', obj);
          }
        }
      });
    $('.close_button').click(() => {
      disableTools(false);
      $('#snaps_choice').hide();
      if (state.lastMode) activateTool(true, state.lastMode === 'snapshot' ? 'pan' : state.lastMode);
    });
    $('.snaps-sample').click(() => {
      downloadSamples(settings);
    });
    $('#showHideArrow').click(() => {
      showHideSidebar(ol.map, state);
    });
    $('#version_prompt').click(() => {
      showError({ title: 'Version', message: sa_version, state });
    });

    $('.sn_layer_list .more').click(e => {
      if ($(e.currentTarget).find('i').first().hasClass('fa-minus')) {
        $(e.currentTarget).find('i').first().removeClass('fa-minus');
        $(e.currentTarget).find('i').first().addClass('fa-plus');
        $('.hidden_section').hide();
      } else {
        $('.hidden_section').hide();
        const grp = e.currentTarget.dataset.group;
        $('.sn_layer_list .more i').addClass('fa-plus');
        $('.sn_layer_list .more i').removeClass('fa-minus');
        $(e.currentTarget).find('i').first().addClass('fa-minus').removeClass('fa-plus');
        $(`#${grp}_section`).show();
        resetClicks();
        setSliderEvents();
        state.snapshotLayers = [...new Set(state.snapshotLayers)];
        state.snapshotGroups = [...new Set(state.snapshotGroups)];
      }
    });
    $('#report_info .ok')
      .off()
      .click(() => {
        $('#report_info').hide();
      });
    $('#draw_new')
      .off()
      .click(() => {
        activeSnapshotDraw();
        snaps_draw();
      });
    $('#use_existing')
      .off()
      .click(() => {
        $('#snaps_choice').hide();
        $('#snapshot_existing_step1').show();
        snaps_useExisting();
      });
    $('#snapshot-tool').hide();
    $('#snapshot_bar').hide();
    $('#delete-tool').hide();
    $('#intersect-tool').hide();
    $('.do_title').click(function (e) {
      const dl = $($(e.currentTarget).parent().find('.data_layers'));
      const fa = $(e.currentTarget).find('.lt-arrow');
      if (dl.css('display') === 'none') {
        $('.data_layers').hide();
        $('.lt-arrow').removeClass('fa-angle-down');
        $('.lt-arrow').addClass('fa-angle-right');
        fa.addClass('fa-angle-down');
        fa.removeClass('fa-angle-right');
        dl.show();
      } else {
        $('.data_layers').hide();
        fa.removeClass('fa-angle-down');
        fa.addClass('fa-angle-right');
        dl.hide();
      }
    });
    $('.data_layers li').hover(layerOver, layerOut);
    $('[data-toggle="tooltip"]').tooltip({ html: true });
    $('#confirm-use-plan').click(function () {
      if ($('#dnsUsePlan').is(':checked')) {
        setCookie('usePlanSeen', true, 1024);
      }
      $('#blocker').hide();
      $('#usePlanPrompt').hide();
    });

    $('#confirm-whats-new').click(function () {
      if ($('#dnsSnaps').is(':checked')) {
        setCookie('snapshotSeen', true, 1024);
      }
      $('#blocker').hide();
      $('#whatsNew').hide();
    });
    $('.minimize')
      .off()
      .click(function () {
        if ($(this).hasClass('fa-minus-square') || !state.progressMinimized) {
          state.progressMinimized = true;
          $('.fa-minus-square').addClass('fa-window-maximize');
          $('.fa-minus-square').removeClass('fa-minus-square');
          $('#snapshot_progress').removeClass('maximized');
          $('#snapshot_progress').addClass('minimized');
        } else {
          state.progressMinimized = false;
          $('.fa-window-maximize').addClass('fa-minus-square');
          $('.fa-window-maximize').removeClass('fa-window-maximize');
          $('#snapshot_progress').removeClass('minimized');
          $('#snapshot_progress').addClass('maximized');
        }
        $('#blocker').hide();
        $('#whatsNew').hide();
      });
    $('.minimize')
      .off()
      .click(function () {
        if ($(this).hasClass('fa-minus-square')) {
          $('.fa-minus-square').addClass('fa-window-maximize');
          $('.fa-minus-square').removeClass('fa-minus-square');
          $('#snapshot_progress').removeClass('maximized');
          $('#snapshot_progress').addClass('minimized');
        } else {
          $('.fa-window-maximize').addClass('fa-minus-square');
          $('.fa-window-maximize').removeClass('fa-window-maximize');
          $('#snapshot_progress').removeClass('minimized');
          $('#snapshot_progress').addClass('maximized');
        }
      });
    $('#downloadSaved').click(() => {
      window.downloadTitles(state.savedFeatures, state);
    });
    $('#snaps-button')
      .off()
      .click(function () {
        snapsAddress();
      });
    $('#confirm-search').off().click(getAllPolygons);
    $('#use-plan').off().click(usePlan);
    $('#plan-cancel').off().click(planCancel);
    $('#plan-confirm')
      .off()
      .click(() => confirmBoundary());
    $('#boundary-cancel').off().click(cancelBoundary);
    $('#boundary-confirm')
      .off()
      .click(() => confirmBoundary());
    $('body').off().on('keydown', keyboardHandler);
    $('body').on('keyup', keyboardUpHandler);

    callback();
  });
};
// Initialization
$(function () {
  UISetup(() => {
    EventBroker.subscribe('getCoordsFromUPRNResult', e => {
      const res = e.response;
      res.forEach(f => {
        const point = new OpenLayers.Geometry.Point(f.coord[0], f.coord[1]);
        const newStyle = {};
        const feat = new OpenLayers.Feature.Vector(point, null, styles.augment(newStyle, colors.red, 2, 1, colors.red));
        feat.style.pointRadius = '4';
        feat.style.labelAlign = 'cb';
        feat.style.fontColor = '#FF0000';
        feat.style.fontSize = '12px';
        feat.style.fontFamily = 'Arial';
        feat.style.fontWeight = 'bold';
        feat.attributes = f.attributes;
        feat.style.strokeColor = colors.black;
        feat.style.strokeWidth = 1;
        ol.layers.tempMarkup.addFeatures([feat]);
      });
      ol.layers.tempMarkup.redraw();
      setRestricted(null);
      state.currentUPRNPoint = 0;
      const c = new OpenLayers.LonLat(res[0].coord[0], res[0].coord[1]);
      ol.map.setCenter(c);
      setRestricted(new OpenLayers.Bounds(c.lon - 5162, c.lat - 5162, c.lon + 5162, c.lat + 5162));
    });
    EventBroker.subscribe('searchResult', e => {
      const res = JSON.parse(e.response);
      const arr = [];
      res.forEach(titles => {
        if (Array.isArray(titles)) {
          titles.forEach(title => {
            arr.push(title);
          });
        } else arr.push(titles);
      });
      e.special = { fromSearch: true };
      e.response = JSON.stringify(arr);
      populateIntersects(e, false);
    });
    EventBroker.subscribe('getLayersFromExtentResult', e => {
      state.coverage = e.response.coverage;
      handleLayerRestrictions({ state });
      resetClicks();
      setSliderEvents();
    });
    EventBroker.subscribe('getUpdatedResult', e => {
      state.updatedData = e.response.updatedData || [];
    });
    ServiceCalls.callService('getUpdated');
    // OSGB Projection defs
    Proj4js.defs['EPSG:27700'] =
      '+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +datum=OSGB36 +units=m +no_defs';
    ol.osgb = new OpenLayers.Projection('EPSG:27700');

    document.documentElement.setAttribute('data-useragent', navigator.userAgent);
    eventHandlers();
    if (sessionStorage.getItem('session-' + guid)) {
      state.lses = JSON.parse(sessionStorage.getItem('session-' + guid));
      state.initx = state.lses.center.lon || state.lses.center[0];
      state.inity = state.lses.center.lat || state.lses.center[1];
      state.startzoom = state.lses.zoom;
      if (state.lses.vector) session = JSON.parse(state.lses.vector);
    }
    if (typeof session !== 'undefined') {
      if (session.length == 0) {
        state.initx = initcoords.x;
        state.inity = initcoords.y;
      } else {
        if (session.center) {
          state.initx = session.center.lon;
          state.inity = session.center.lat;
        }
        if (typeof session.features !== 'undefined') session = session.features;
        if (session[0] && typeof session[0].centre == 'undefined')
          session[0].centre = session[0].properties.bb_centroid;
        if (session[0] && session[0].centre && !state.lses) {
          state.initx = session[0].centre[0];
          state.inity = session[0].centre[1];
        }
      }
    }
    if (typeof raillayers != 'undefined' && raillayers !== '') {
      raillayers.split(',').forEach(r => {
        $(`#${r.replace(' ', '')}-layer`)
          .removeClass('nowshow')
          .addClass('show');
      });
    }
    handleLayerRestrictions({ state, auth, origcountry, county, wmslayercheck });
    resetClicks();
    setSliderEvents();

    state.coverage = { wmslayercheck, restrict: { origcountry, county, auth } };
    if (typeof initcoords != 'undefined' && !state.lses) {
      state.initx = initcoords.x;
      state.inity = initcoords.y;
    }
    if (typeof initcoords != 'undefined') {
      state.markerLocation = { x: initcoords.x, y: initcoords.y };
    } else {
      state.markerLocation = { x: state.initx, y: state.inity };
    }

    const rend = { styleMap: new OpenLayers.StyleMap(styles.defaultStyle), renderers: ['Canvas', 'SVG', 'VML'] };
    ol.vectorList.forEach(l => {
      ol.layers[l] = new OpenLayers.Layer.Vector(`${l}_Vector`, { ...rend });
    });
    const markerPoint = new OpenLayers.Geometry.Point(state.markerLocation.x, state.markerLocation.y);
    const markerPoint2 = new OpenLayers.Geometry.Point(state.markerLocation.x, state.markerLocation.y);
    const svPoint = new OpenLayers.Geometry.Point(state.initx, state.inity);
    ol.points.marker = new OpenLayers.Feature.Vector(markerPoint, null, {
      externalGraphic: 'assets/img/builtby.png',
      graphicWidth: 35,
      graphicHeight: 31,
      fillOpacity: 1,
      display: 'block',
    });
    ol.points.marker2 = new OpenLayers.Feature.Vector(markerPoint2, null, {
      externalGraphic: 'assets/img/builtby2.png',
      graphicWidth: 35,
      graphicHeight: 31,
      fillOpacity: 1,
      display: 'block',
    });
    ol.points.markerSV = new OpenLayers.Feature.Vector(svPoint, null, {
      externalGraphic: 'assets/img/streetview.png',
      graphicWidth: 16,
      graphicHeight: 17,
      fillOpacity: 1,
      display: 'none',
    });
    ol.layers.vector2.events.on({
      featuresremoved: featuresRemoved,
      featuresadded: featuresAdded,
      featureadded: storeSession,
      beforefeaturemodified: selectFeature,
      featureunselected: unselectFeature,
      afterfeaturemodified: checkPolySearch,
      featuremodified: checkBoundaryMove,
    });
    ol.layers.vector.events.on({
      featuresremoved: featuresRemoved,
      featuresadded: featuresAdded,
      beforefeaturemodified: cloneFeature,
      afterfeaturemodified: changeFeatureToAnnotation,
      featuremodified: registerModify,
    });
    ol.layers.vectorOverview.events.on({
      featureselected: e => console.log(e),
    });
    OpenLayers.Control.DoubleClick = OpenLayers.Class(OpenLayers.Control, {
      defaultHandlerOptions: {
        single: false,
        double: true,
        pixelTolerance: 0,
        stopDouble: true,
      },
      initialize: function () {
        this.handlerOptions = OpenLayers.Util.extend({}, this.defaultHandlerOptions);
        OpenLayers.Control.prototype.initialize.apply(this, arguments);
        this.handler = new OpenLayers.Handler.Click(
          this,
          {
            dblclick: this.trigger,
          },
          this.handlerOptions,
        );
      },

      trigger: function () {
        state.snapsActive = true;
        if (goodSnapshot(state.snapFeatures)) {
          showSnapshotOrder();
        } else if (state.snapshotFeatures[0].geometry.getArea() > (settings.maxSnapshot || 100000000)) {
          setArea({ feat: state.snapshotFeatures[0], pa: false });
          showError({
            state,
            title: 'Data Snapshot Boundary Error',
            message: messages.tooLarge,
          });
        } else {
          showError({
            state,
            title: 'Data Snapshot Boundary Error',
            message: messages.multi,
          });
        }
      },
    });

    OpenLayers.Control.DoubleClickOverview = OpenLayers.Class(OpenLayers.Control, {
      defaultHandlerOptions: {
        single: false,
        double: true,
        pixelTolerance: 0,
        stopDouble: true,
      },
      initialize: function () {
        this.handlerOptions = OpenLayers.Util.extend({}, this.defaultHandlerOptions);
        OpenLayers.Control.prototype.initialize.apply(this, arguments);
        this.handler = new OpenLayers.Handler.Click(
          this,
          {
            dblclick: this.trigger,
          },
          this.handlerOptions,
        );
      },

      trigger: function (e) {
        const feat = ol.layers.vectorOverview.getFeatureFromEvent(e);
        let zoom, bounds;
        if (feat.group.length === 1) {
          bounds = feat.group[0].geometry.bounds;
          zoom = ol.map.getZoomForExtent(bounds, true);
          ol.map.setCenter(feat.group[0].geometry.bounds.getCenterLonLat());
          ol.map.zoomTo(zoom - 1);
        } else {
          const tl = new OpenLayers.Layer.Vector('temp', {
            styleMap: new OpenLayers.StyleMap(styles.defaultStyle),
            renderers: ['Canvas', 'SVG', 'VML'],
          });
          tl.addFeatures(feat.group);
          bounds = tl.getDataExtent();
          const center = [
            (bounds.right - bounds.left) / 2 + bounds.left,
            (bounds.top - bounds.bottom) / 2 + bounds.bottom,
          ];
          ol.map.setCenter(center);
          zoom = ol.map.getZoomForExtent(bounds, true);
          if (zoom >= 4) zoom--;
          ol.map.zoomTo(zoom);
        }
      },
    });

    OpenLayers.Control.Click = OpenLayers.Class(OpenLayers.Control, {
      defaultHandlerOptions: {
        single: true,
        double: false,
        pixelTolerance: 0,
        stopSingle: false,
        stopDouble: false,
      },

      initialize: function () {
        this.handlerOptions = OpenLayers.Util.extend({}, this.defaultHandlerOptions);
        OpenLayers.Control.prototype.initialize.apply(this, arguments);
        this.handler = new OpenLayers.Handler.Click(
          this,
          {
            click: this.trigger,
          },
          this.handlerOptions,
        );
      },

      trigger: function (e) {
        if (!state.moving) {
          busyPointer();
          const lonlat = ol.map.getLonLatFromPixel(e.xy);
          if (e.ctrlKey && e.altKey) {
            showDialog(e);
          } else if (state.curKey == 84) {
            return false;
          } else {
            ServiceCalls.callService('getTitleFromPoint', {
              lonlat: lonlat,
            });
          }
        }
      },
    });
    const mod = {
      toggle: false,
      title: 'Modify Annotation',
      vertexRenderIntent: 'vertexIcon',
      virtualStyle: styles.vertexIcon,
    };
    [
      { c: 'modifyLR', l: 'vector' },
      { c: 'modifyFeature', l: 'vector2' },
    ].forEach(m => {
      ol.controls[m.c] = new OpenLayers.Control.ModifyFeaturePro(ol.layers[m.l], { ...mod });
      ol.controls[m.c].mode |= OpenLayers.Control.ModifyFeature.DRAG;
    });
    ol.controls.addPath = new OpenLayers.Control.MeasurePro(ol.layers.vector2, OpenLayers.Handler.Path, {
      displayClass: 'olControlDrawFeaturePath',
      featureAdded: function (feature) {
        featureAdded(feature, 'path');
      },
    });
    ol.controls.polyTitle = new OpenLayers.Control.DrawFeature(ol.layers.vector2, OpenLayers.Handler.Polygon, {
      displayClass: 'olControlDrawFeaturePolygon',
      featureAdded: function (feature) {
        featureAdded(feature, 'property');
      },
      callbacks: {
        point: function () {
          $('#editToolbar').show();
          $('#undo-redo').show();
        },
      },
    });
    OpenLayers.Event.observe(document, 'keydown', function (evt) {
      if ($('#undo-redo').is(':visible') || $('#undo-redo-other').is(':visible') || state.fillHistoryPointer !== -1) {
        switch (evt.key) {
          case 'u':
            doUndo({ state, ol });
            break;
          case 'r':
            doRedo({ state, ol });
            break;
        }
      }
    });
    ol.controls.addPoly = new OpenLayers.Control.DrawFeature(ol.layers.vector2, OpenLayers.Handler.Polygon, {
      displayClass: 'olControlDrawFeaturePolygon',
      featureAdded: function (feature) {
        featureAdded(feature, 'poly');
      },
      handlerOptions: {
        holeModifier: 'altKey',
        freehandToggle: 'shiftKey',
      },

      callbacks: {
        point: function () {
          $('#undo-redo-other').show();
        },
      },
    });
    ol.controls.snap = new OpenLayers.Control.Snapping({
      layer: ol.layers.vector2,
      defaults: {
        tolerance: 15,
        edge: true,
      },
      targets: [
        { layer: ol.layers.wfs, tolerance: 15 },
        { layer: ol.layers.vector2, tolerance: 15 },
      ],
    });
    ol.controls.snap.activate();
    ol.controls.mousePositionCtrl = new OpenLayers.Control.MousePosition({
      numDigits: 2,
    });
    ol.featuresClicked = [];
    ol.map = new OpenLayers.Map({
      div: 'map',
      resolutions: ol.resolutions,
      fallThrough: true,
      projection: ol.osgb,
      units: 'm',
      numZoomLevels: 15,
      extent: [0, 0, 671196, 1376256.0],
      restrictedExtent: [state.initx - 5162, state.inity - 5162, state.initx + 5162, state.inity + 5162],
      maxExtent: [-238375.0, 0, 671196.3657, 1376256.0454],
      controls: [new OpenLayers.Control.Zoom()],
      eventListeners: {
        zoomstart: function () {},
        zoomend: function () {
          if (state.zoomTimeout) clearTimeout(state.zoomTimeout);
          state.zoomTimeout = setTimeout(() => {
            if (ol.map.getZoom() >= 7) {
              updateRelevancy();
              clearTimeout(state.zoomTimeout);
            }
          }, 1000);
        },
        featureout: function (e) {
          state.overStatus = false;
          if (e.feature.type != 'annotation' && !state.selectActive) {
            if (state.overcount > 0) state.overcount--;
            if (state.overcount === 0) {
              if (
                !state.queryActive &&
                !state.boundaryActive &&
                !state.infoActive &&
                !state.drawActive &&
                !state.modifyActive
              ) {
                $('#output').empty();
                setCursor({ type: 'default' });
                if ($('#pan-control').parent().hasClass('active')) ol.controls.click.activate();
              } else {
                state.overcount = 0;
              }
            }
          } else if (state.selectActive && !state.modifyActive && !state.selectTimer) {
            $('#output').empty();
            setCursor({ type: 'default' });
          }
        },
      },
    });
    ol.map.zoomToProxy = ol.map.zoomTo;
    ol.map.zoomTo = function (zoom, xy) {
      //Your Before Zoom Actions
      let zLevel = zoom;
      if (zLevel > state.restrictTitleNumbersLevel) {
        $('#title_numbers').removeAttr('disabled');
      }
      if (state.currentBM == 'mmLayer' || state.currentBM == 'bwLayer') {
        if (zLevel === -1) zLevel = 0;
        const el = $('[data-layer="vw_landreg_titles_address_lookup"],[data-layer="vw_lu_landreg_titles_number"]');
        if (zLevel <= state.oscheck) {
          setRestricted(null);
          $('#edit_toolbar').hide();
          $('#identify_toolbar').hide();
          if (zLevel !== state.prevZoom) {
            state.lrwasChecked = [];
            if (el[0].checked) {
              $('[data-layer="vw_landreg_titles_address_lookup"],[data-layer="vw_lu_landreg_titles_number"]').each(
                function () {
                  state.lrwasChecked.push(this.checked);
                },
              );
              $(el[0]).click();
            }
            $('.lrcheck').attr('disabled', true);
          }
          if (state.currentBM === 'mmLayer') {
            ol.map.setBaseLayer(ol.layers.OSopen);
          } else {
            ol.map.setBaseLayer(ol.layers.OSopen);
          }
          ol.functions.setUpOverview(ol.layers.vector.features, zLevel);
          ol.layers.vector.setVisibility(false);
          ol.layers.vectorOverview.setVisibility(true);
          ol.layers.vectorOverview.setZIndex(3000);
          ol.layers.vectorPin.setVisibility(false);
        } else if (zLevel < state.lcheck) {
          $('#edit_toolbar').show();
          $('#identify_toolbar').show();
          ol.layers.vector.setVisibility(true);
          ol.layers.vectorOverview.setVisibility(false);
          ol.layers.vectorPin.setVisibility(true);
          setRestricted(null);
          $('.lrcheck').removeAttr('disabled', true);
          if (zLevel <= state.restrictTitleNumbersLevel) {
            if ($('#title_numbers').is(':checked')) {
              state.titleNumbersChecked = true;
              $('#title_numbers').click();
            }
            $('#title_numbers').attr('disabled', 'disabled');
          }
          if (state.lrwasChecked.length) {
            for (let i = 1; i < 5; i++) {
              if (state.lrwasChecked[i]) {
                $(el[i]).click();
              }
            }
            state.lrwasChecked = [];
          }
          if (state.currentBM === 'mmLayer') {
            ol.layers.mmLayer.setVisibility(false);
            ol.map.setBaseLayer(ol.layers.vmlLayer);
          } else {
            ol.map.setBaseLayer(ol.layers.omlLayerBW);
          }
        } else {
          ol.layers.vector.setVisibility(true);
          ol.layers.vectorOverview.setVisibility(false);
          ol.layers.vectorPin.setVisibility(true);
          $('.lrcheck').removeAttr('disabled');
          let c = ol.map.getCenter();
          if (!ol.map.restrictedExtent)
            setRestricted(new OpenLayers.Bounds(c.lon - 5162, c.lat - 5162, c.lon + 5162, c.lat + 5162));
          if (zLevel <= state.restrictTitleNumbersLevel) {
            if ($('#title_numbers').is(':checked')) {
              state.titleNumbersChecked = true;
              $('#title_numbers').click();
            }
            $('#title_numbers').attr('disabled', 'disabled');
          }
          if (state.currentBM === 'mmLayer') {
            ol.map.setBaseLayer(ol.layers.mmLayer);
          } else {
            ol.map.setBaseLayer(ol.layers.bwLayer);
          }
        }
      }
      if (zLevel <= 6) {
        if (!$('.bottom-row').hasClass('disabled')) disableLayers(true);
      } else {
        if ($('.bottom-row').hasClass('disabled')) disableLayers(false);
      }
      if (zLevel > 7) {
        $('.coal .layercb').each((index, o) => {
          if ($(o).is(':checked')) $(o).click();
        });
      }
      state.prevZoom = zLevel;
      // Check Non MM level layers
      if (zoom > 10) {
        $('.nomm').each((index, obj) => {
          if ($(obj).is(':checked')) {
            $(obj).click();
          }
        });
      }
      //If you want zoom to go through call
      ol.map.zoomToProxy(zoom, xy);
      //else do nothing and map wont zoom
    };
    const Navigation = new OpenLayers.Control.Navigation({
      defaultDblClick: function () {
        return;
      },
      zoomWheelEnabled: false,
      mouseWheelOptions: {
        cumulative: true,
      },
    });
    const Touch = new OpenLayers.Control.TouchNavigation({
      dragPanOptions: {
        enableKinetic: true,
      },
      defaultDblClick: function () {
        return;
      },
    });
    ol.map.addControl(Navigation);
    ol.map.addControl(Touch);
    ol.layers.vector.events.on({
      featureover: callFeatureOver,
      featureclick: featClick,
    });
    ol.layers.vector2.events.on({
      featureover: callFeatureOver,
      featureclick: polyClick,
    });
    ol.layers.vectorSel.events.on({
      featureover: callFeatureOver,
      featureclick: selClick,
    });
    ['vector', 'vector2', 'vectorPin'].forEach(v => (ol.layers[v].events.fallThrough = true));
    ol.layers.error.events.fallThrough = false;
    ol.layers.vectorPin.events.on({
      featureclick: function () {
        return false;
      },
    });
    ol.layers.error.events.on({
      featureclick: function () {
        ol.layers.error.removeFeatures([ol.points.error]);
        if (ol.popup) {
          ol.map.removePopup(ol.map.popups[0]);
          ol.popup = null;
        }
        event.preventDefault();
        event.stopPropagation();
        return false;
      },
    });
    ol.map.events.register('movestart', ol.map, function () {
      state.moving = true;
    });
    ol.map.events.register('moveend', ol.map, function () {
      const ext = ol.map.getExtent();
      const halfX = Math.ceil((ext.right - ext.left) / 2);
      const halfY = Math.ceil((ext.top - ext.bottom) / 2);
      let zLevel = ol.map.getZoom();
      if (zLevel >= 7) {
        setTimeout(function () {
          if (
            state.currentCenter &&
            (Math.abs(ol.map.center.lon - state.currentCenter.x) > halfX ||
              Math.abs(ol.map.center.lat - state.currentCenter.y) > halfY)
          ) {
            updateRelevancy();
          }
        }, 400);
      }
      state.moving = false;
    });
    ol.map.events.register('mousemove', ol.map, function (e) {
      state.mousePos = ol.map.getLonLatFromPixel(this.events.getMousePosition(e));
    });
    ol.baseMaps.forEach(l => {
      ol.layers[l].events.register('loadstart', ol.map, onloadstart);
      ol.layers[l].events.register('loadend', ol.map, onloadend);
    });
    ol.layers.aerialLayer.events.register('loadend', ol.map, onloadend);
    ['wmsInfo2', 'wmsInfo3'].forEach(w => {
      ol.controls[w].events.register('beforegetfeatureinfo', ol.map, busyPointer);
      ol.controls[w].events.register('nogetfeatureinfo', ol.map, () => {
        setCursor({ type: 'help', state });
      });
      ol.controls[w].events.register('getfeatureinfo', ol.map, e => showWMSInfo({ evt: e, state, ol, settings }));
    });
    ol.controls.wfsInfo.events.register('featureselected', ol.map, drawWFS);

    Object.keys(ol.layers).forEach(k => {
      k !== 'shadowMap' && ol.layers[k] && ol.map.addLayer(ol.layers[k]);
    });

    //* Show polygons that have changed //*
    // ol.layers.wfs.events.register('beforefeaturesadded', ol.layers.wfs, feats => {
    //   let newFeats = [];
    //   feats.features.forEach(f => {
    //     if (
    //       f.attributes &&
    //       f.attributes.lastchdate &&
    //       f.attributes.lastchreas === 'New' &&
    //#       !state.toids.includes(f.attributes.toid) &&
    //       f.attributes.descgroup === 'Building' &&
    //       new Date(f.attributes.lastchdate).getTime() > new Date('2019-01-01Z').getTime()
    //     ) {
    //       const newFeat = new OpenLayers.Feature.Vector(f.geometry.clone());
    //       state.toids.push(f.attributes.toid);
    //       let newStyle = { ...styles.defaultStyle };
    //       newFeat.style = styles.augment(newStyle, '#ffffff', 1, 0.3, '#00ffff', 0.01);
    //       newFeat.type = 'annotation';
    //       newFeats.push(newFeat);
    //     }
    //   });
    //   ol.layers.vector2.addFeatures(newFeats);
    // });
    ol.layers.vectorOverview.setVisibility(false);
    ol.layers.vectorPin.addFeatures([ol.points.marker, ol.points.markerSV]);
    const ix = state.initx;
    const iy = state.inity;
    ol.map.setCenter(new OpenLayers.LonLat(ix, iy), state.startzoom);
    state.currentCenter = { x: ix, y: iy };
    ol.controls.click = new OpenLayers.Control.Click();
    ol.controls.doubleClick = new OpenLayers.Control.DoubleClick();
    ol.controls.doubleClickOverview = new OpenLayers.Control.DoubleClickOverview();
    Object.keys(ol.controls).forEach(c => {
      if (ol.controls[c]) ol.map.addControl(ol.controls[c]);
    });
    activateTool(null, 'pan');
    ol.functions.setIndexes({ ol });
    if (typeof session !== 'undefined') {
      showInitialBoundary(session);
    }
    ol.controls.dragmarker = new OpenLayers.Control.DragFeature(ol.layers.vectorPin, {
      onComplete: function (m) {
        state.initx = m.geometry.x;
        state.inity = m.geometry.y;
      },
    });
    ol.map.addControl(ol.controls.dragmarker);
  });
});
window.openhelp = openhelp;
window.ol = ol;
window.populateHelp = populateHelp;
window.showTab = showTab;
window.downloadTitles = downloadTitles;
window.showSection = showSection;
window.removeSaved = removeSaved;
window.downloadFile = downloadFile;
